import React, { useEffect, useMemo, useState } from "react"
import { enumUtil } from "../../../../../utils/Enum"
import NotificationHandler from "../../../../../utils/NotificationHandler"
import FormValidator from "../../../../../utils/FormValidator"
import isNull from "../../../../../utils/NullChecking"
import { ServerRequestProtected, ServerRequestPublic } from "../../../../../utils/ServerDataRequest"
import Loader from "../../../../shared/Loader/Loader"
import Modal from 'react-bootstrap/Modal';
import DeleteConfirmatiom from "../../../../General/DeleteConfirmation"
import Audit from "../../../../General/Audit"
import ModalFooter from "../../../../Setup/Shared/ModalFooter"
import format from "date-fns/format"
import handleNumericCheck from "../../../../../utils/HandleNumericKeys"
import SuperSearchList from "../../../../shared/SuperSearch/SuperSearchList"
import { useSelector } from "react-redux"
import ModalHeader from "../../../../Setup/Shared/ModalHeader"
import moment from "moment/moment"
import DateValidator from "../../../../../utils/DateValidator"
import FormatDate from "../../../../shared/DateFormatter"
import DatePicker from '../../../../General/DatePicker';
import { AuthorizationFrequency, AuthorizationFrequencyHomeCare } from "../../../../../utils/Constants"
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { saveAs } from "file-saver"
import { Form } from "react-bootstrap"
import OpenQuickPopup from "../../../../shared/OpenQuickPopup/OpenQuickPopup"
import DiagnosisSearch from "../../../../shared/AdvanceSearches/DiagnosisSearch"
import ProcedureSearch from "../../../../shared/AdvanceSearches/ProcedureSearch"
import { FindFirstChild } from "../../../../../utils/FindMenuOption"
import AuthorizedUpdatePopup from "./AuthorizedUpdatePopup"
import NpiRegistry from "../../../../General/NpiRegistry"
import Pdfdetail from "../../../../General/pdfdetail"
import { PdfIcon } from "../../../../shared/IconsComponent/icons"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AmountFormatter from "../../../../../utils/AmountFormatter"
import SuperSearch from "../../../../shared/SuperSearch/SuperSearch"
import AddNewProcedureCodes from "../../../../Setup/Coding/ProcedureCode/AddNewProcedureCodes"
import AddNewDiagnosis from "../../../../Setup/Coding/DiagnosisCode/AddNewDiagnosis"
import SuperICDandCPTSearch from "../../../../shared/SuperSearch/ICDAndCPTSelection/SuperICDandCPTSearch"
const AddNewAuthorization = (props) => {
    let IsEditAllowed = FindFirstChild('Patient', 'Authorization')?.IsAdd
    let IsDeleteAllowed = FindFirstChild('Patient', 'Authorization')?.IsDeleted
    let isADC = useSelector(state => state.GeneralDropDownsReducer.PracticeType === "Adult Day Care")
    let RecentICDs = useSelector(state => state.CodesDropDownReducer.RecentICD)
    let RecentCPTs = useSelector(state => state.CodesDropDownReducer.RecentCPT)

    const API_URL = enumUtil.controller.PATIENT
    const API_URL_Search = enumUtil.controller.General
    const API_URL_Claim = enumUtil.controller.Claim
    const API_URL_Wasabi = enumUtil.controller.Wasabi
    const { IsOpenAuthorization, onClose, InsuranceListModal, isReadOnly, onDeleteInsurance, npiModal, proceedHeader, onCloseProocedNpi, type, PatientID, UpdateFiledStatus, authModal, DataImportMenu, handleProcessPendingData } = { ...props }
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [isOpenAuthorized, setisOpenAuthorized] = useState(false);
    const [claimCounts, setclaimCounts] = useState();
    const [isOpenRegistry, setIsOpenRegistry] = useState(false);
    const [NpiRegistryNumber, setNpiRegistryNumber] = useState('');
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const isHomeCareCheck = DropDowns.IsHomeCare
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = !isNull(PatientID) ? PatientID : PateintIDR?.data?.id
    const AuthorizationType = [
        { value: '', display: 'Select Type' },
        { value: 'Medical', display: 'Medical' },
        { value: 'Dental', display: 'Dental' },
        { value: 'Surgical', display: 'Surgical' },
        { value: 'Therapy', display: 'Therapy' },
    ]
    const AuthorizationStatus = [
        { value: '', display: '' },
        { value: 'Active', display: 'Active' },
        { value: 'Expired', display: 'Expired' },
        { value: 'Expiring', display: 'Expiring' },
    ]
    let Authorization_Modal = {
        AuthorizationType: "",
        PatientID: "",
        PatientInsuranceID: "",
        InsuranceID: "",
        ProviderID: "",
        LocationID: "",
        DiagnosisCode1: "",
        DiagnosisCode2: "",
        DiagnosisCode3: "",
        DiagnosisCode4: "",
        ProcedureCode: "",
        AuthorizationNumber: "",
        StartDate: null,
        EndDate: null,
        AuthorizationStatus: "Active",
        VisitsAllowed: "",
        Remarks: "",
        AuthorizeUnits: "",
        UtilizedUnits: "",
        RemainingUnits: "",
        UnitsFrequency: "",
        InsuranceType: "",
        ProviderFeeScheduleID: "",
        Status: '',
        Frequency: 'Weekly',
        AuthorizationDocument: '',
        FileName: '',
        AdditionalCPTCode: '',
        Mon: "",
        Tue: "",
        Wed: "",
        Thu: "",
        Fri: "",
        Sat: "",
        Sun: "",
        MonMax: "",
        MonMin: "",
        TueMax: "",
        TueMin: "",
        WedMax: "",
        WedMin: "",
        ThuMax: "",
        ThuMin: "",
        FriMax: "",
        FriMin: "",
        SatMax: "",
        SatMin: "",
        SunMax: "",
        SunMin: "",
        DailyLimitMin: "",
        DailyLimitMax: "",
        isScheduleFloating: false,
        isScheduleDaily: true,
        isSplitShift: false,
        isLiveIn: false,
        ProcedureCodeID: "",
        CountyAmount: "",
        Notes: "",
        IsTranspotation: false,
    }
    let valModal = {}
    // validation modal 
    let ValidationModal = {
        InusranceIDVal: "",
        ProcedureCodeVal: "",
        AuthorizationNumberVal: "",
        UnitsFrequencyVal: "",
        AuthorizedUnitLengthVal: "",
        AuthorizedUnitsVal: '',
        StartDateval: "",
        EndDateVal: ""
    }
    let AuthFile_Validation = {
        UploadedFile: ''
    }
    let AuthFile_Val_Modal = '';
    const [BillingEntityID, setBillingEntityID] = useState('')
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const [mainAuthorizationModal, setmainAuthorizationModal] = useState(Authorization_Modal);
    const [AuthorizationSaveUpdateModal, setAuthorizationSaveUpdateModal] = useState({})
    const [AuthorizationValidationModal, setAuthorizationValidationModal] = useState(ValidationModal);
    const [AuthFileValidation, setAuthFileValidation] = useState(AuthFile_Validation);
    const [AuthorizationID, setAuthorizationID] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [UpdateAuthorizationNumber, setUpdateAuthorizationNumber] = useState(false);
    const [NewAuthorizationNumber, setNewAuthorizationNumber] = useState(null);
    const [onInsuranceSave, setOnInsuranceSave] = useState(false)
    const [cptBody, setcptBody] = useState({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": '' })
    const [icdBody, setIcdBody] = useState({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": '' })
    const [pdfFile, setPdfFile] = useState(null);
    const [txtFile, setTxtFile] = useState(null);
    const [imgFile, setImgFile] = useState(null);
    const [modalActive, setModalActive] = useState(false)
    const [is, setIs] = useState(true);
    const [curSelectedICD, setcurSelectedICD] = useState('')
    const [selectedClaimId, setSelectedClaimID] = useState([])
    const [isOpenICDSearch, setisOpenICDSearch] = useState(false);
    const [selectedRows, setSelectedRows] = useState(new Set())
    const [isOpenCPT, setisOpenCPT] = useState(false);
    const [AdditionalCPT, setAdditionalCPT] = useState('')
    const [modifierBody, setmodifierBody] = useState({ "TableName": enumUtil.enumAPITableName.Modifier, "SearchParam": '' })
    const [curIndex, setCurIndex] = useState();
    const [OCRType, setOCRType] = useState(null);
    const [popup, setPopup] = useState(<></>);
    const [perUnitHours, setPerUnitHours] = useState('')
    const [previousAuthorizationNumber, setPreviousAuthorizationNumber] = useState('');
    let icd1 = useMemo(() => { return <OpenQuickPopup ID={mainAuthorizationModal.DiagnosisCode1 + ""} name={'ICD1'} setPopup={setPopup} popupName={'Procedure Macro'} type={"Label"} /> }, [mainAuthorizationModal])
    let icd2 = useMemo(() => { return <OpenQuickPopup ID={mainAuthorizationModal.DiagnosisCode2 + ""} name={'ICD2'} setPopup={setPopup} popupName={'Procedure Macro'} type={"Label"} /> }, [mainAuthorizationModal])
    let icd3 = useMemo(() => { return <OpenQuickPopup ID={mainAuthorizationModal.DiagnosisCode3 + ""} name={'ICD3'} setPopup={setPopup} popupName={'Procedure Macro'} type={"Label"} /> }, [mainAuthorizationModal])
    let icd4 = useMemo(() => { return <OpenQuickPopup ID={mainAuthorizationModal.DiagnosisCode4 + ""} name={'ICD4'} setPopup={setPopup} popupName={'Procedure Macro'} type={"Label"} /> }, [mainAuthorizationModal])
    let valoModalDate = {}
    let dateValidation = {
        DateVal: '',
    }
    const CloseRegistry = (data) => {
        setIs(true)
        // if (data === NpiRegistryNumber) {
        //     setNpiRegistryNumber(data)
        // }

        setIsOpenRegistry(false)
    }
    const ApplyFileChanges = (OCRData) => {
        const mainModal = { ...mainAuthorizationModal }
        const saveModal = { ...AuthorizationSaveUpdateModal }

        let cpt = ''
        let addCpt = ''
        OCRData?.cptDetailslist.map((item, index) => {
            if (index === 0) {
                cpt = item.codes
            } else if (index === 1) {
                addCpt = item.codes
            }
        })
        mainModal['AuthorizationNumber'] = OCRData?.authorizationNo;
        mainModal['StartDate'] = OCRData?.cptDetailslist.length > 0 ? OCRData?.cptDetailslist[0].fromDates : '';
        mainModal['EndDate'] = OCRData?.cptDetailslist.length > 0 ? OCRData?.cptDetailslist[0].toDates : '';
        mainModal['DiagnosisCode1'] = OCRData?.diagnosisCode1 ?? '';
        mainModal['DiagnosisCode2'] = OCRData?.diagnosisCode2 ?? '';
        mainModal['DiagnosisCode3'] = OCRData?.diagnosisCode3 ?? '';
        mainModal['DiagnosisCode4'] = OCRData?.diagnosisCode4 ?? '';
        mainModal['ProcedureCode'] = cpt;
        mainModal['AdditionalCPTCode'] = addCpt;
        mainModal['AuthorizeUnits'] = OCRData?.totalQuantity;

        mainModal['Mon'] = OCRData?.mon
        mainModal['Tue'] = OCRData?.tue
        mainModal['Wed'] = OCRData?.wed
        mainModal['Thu'] = OCRData?.thu
        mainModal['Fri'] = OCRData?.fri
        mainModal['Sat'] = OCRData?.sat
        mainModal['Sun'] = OCRData?.sun

        // mainModal['ScheduleUnits'] = "";
        // mainModal['RemainingUnits'] = "";
        // mainModal['UtilizedUnits'] = "";
        // mainModal['AuthorizationStatus'] = OCRData?.authStatus;
        mainModal['UnitsFrequency'] = OCRData?.unitsFrequency;

        saveModal['AuthorizationNumber'] = OCRData?.authorizationNo;
        saveModal['StartDate'] = OCRData?.cptDetailslist.length > 0 ? OCRData?.cptDetailslist[0].fromDates : '';
        saveModal['EndDate'] = OCRData?.cptDetailslist.length > 0 ? OCRData?.cptDetailslist[0].toDates : '';
        saveModal['DiagnosisCode1'] = OCRData?.diagnosisCode1 ?? '';
        saveModal['DiagnosisCode2'] = OCRData?.diagnosisCode2 ?? '';
        saveModal['DiagnosisCode3'] = OCRData?.diagnosisCode3 ?? '';
        saveModal['DiagnosisCode4'] = OCRData?.diagnosisCode4 ?? '';
        saveModal['DiagnosisCode1ID'] = OCRData?.DiagnosisCode1ID ?? null;
        saveModal['DiagnosisCode2ID'] = OCRData?.DiagnosisCode2ID ?? null;
        saveModal['DiagnosisCode3ID'] = OCRData?.DiagnosisCode3ID ?? null;
        saveModal['DiagnosisCode4ID'] = OCRData?.DiagnosisCode4ID ?? null;
        saveModal['ProcedureCode'] = cpt;
        saveModal['AdditionalCPTCode'] = addCpt;
        saveModal['AuthorizeUnits'] = OCRData?.totalQuantity;

        saveModal['Mon'] = OCRData?.mon
        saveModal['Tue'] = OCRData?.tue
        saveModal['Wed'] = OCRData?.wed
        saveModal['Thu'] = OCRData?.thu
        saveModal['Fri'] = OCRData?.fri
        saveModal['Sat'] = OCRData?.sat
        saveModal['Sun'] = OCRData?.sun
        // saveModal['ScheduleUnits'] = "";
        // saveModal['RemainingUnits'] = "";
        // saveModal['UtilizedUnits'] = "";
        // saveModal['AuthorizationStatus'] = OCRData?.authStatus;
        saveModal['UnitsFrequency'] = OCRData?.unitsFrequency;

        setmainAuthorizationModal(mainModal);
        setAuthorizationSaveUpdateModal(saveModal);

    }

    const [error, setError] = useState(dateValidation);
    // Schedule Type
    const API_URL_FEE = enumUtil.controller.ProviderFeeSchedule
    const [ProgramTypeDD, setProgramTypeDD] = useState([])
    const [CountyDD, setCountyDD] = useState([])
    const [OverallDD, setOverAllDD] = useState([])
    let daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    let split_Data = {
        id: "0",
        Mon: '',
        Tue: '',
        Wed: '',
        Thu: '',
        Fri: '',
        Sat: '',
        Sun: ''
    }
    const [splitShiftData, setsplitShiftData] = useState([])
    const handleChangeSplitData = (e, index) => {
        let { name, value } = e.target
        let data = [...splitShiftData]
        data[index][name] = value
        setsplitShiftData(data)
    }
    const handleAddNewShift = () => {
        let data = [...splitShiftData]
        let lastRow = data[data.length - 1]
        if (!isNull(lastRow)) {
            let allEmpty = true;
            for (let key in lastRow) {
                if (!isNull(lastRow[key]) && lastRow[key] !== '0') {
                    allEmpty = false;
                    break;
                }
            }
            if (allEmpty) {
                NotificationHandler('Add data in last row', enumUtil.enumtoaster.error)
            } else {
                data.push(split_Data)
                setsplitShiftData(data)
            }
        } else {
            data.push(split_Data)
            setsplitShiftData(data)
        }
    }
    // for main
    const calculateUnitsSplit = (hours) => {
        const hoursInt = parseFloat(hours) || 0;
        return hoursInt * 4;
    };
    const calculatetotalHour = () => {
        let modal = { ...mainAuthorizationModal }
        const totalHrs = daysOfWeek
            .map(day => parseInt(modal[day], 10) || 0)
            .reduce((acc, curr) => acc + curr, 0);
        return totalHrs
    }
    const calculatetotalUnit = () => {
        const updatedUnits = {
            Mon: calculateUnitsSplit(mainAuthorizationModal.Mon),
            Tue: calculateUnitsSplit(mainAuthorizationModal.Tue),
            Wed: calculateUnitsSplit(mainAuthorizationModal.Wed),
            Thu: calculateUnitsSplit(mainAuthorizationModal.Thu),
            Fri: calculateUnitsSplit(mainAuthorizationModal.Fri),
            Sat: calculateUnitsSplit(mainAuthorizationModal.Sat),
            Sun: calculateUnitsSplit(mainAuthorizationModal.Sun),
        };
        const totalUnits = daysOfWeek
            .map(day => parseInt(updatedUnits[day], 10) || 0)
            .reduce((acc, curr) => acc + curr, 0);
        return totalUnits;
    };
    let totalHours = calculatetotalHour()
    // for split data
    const calculateTotalHours = (record = {}) => {
        let total = 0;
        total = daysOfWeek.reduce((sum, day) => {
            return sum + (parseInt(record[day] || '0', 10) || 0);
        }, 0);
        return total;
    };
    const calculateTotalSplitUnits = (record) => {
        let totalUnits = 0;
        daysOfWeek.forEach((daysOfWeek) => {
            const hours = record[daysOfWeek];
            totalUnits += calculateUnitsSplit(hours);
        });

        return totalUnits;
    };
    let totaSplitHour = calculateTotalHours()
    //  calCulate Total Of max And Min 
    const TotalMaxAndMin = () => {
        let modal = { ...mainAuthorizationModal };
        // Calculate total minimum hours
        const totalMinHrs = daysOfWeek
            .map(day => parseInt(modal[day + 'Min'], 10) || 0)
            .reduce((acc, curr) => acc + curr, 0);
        // Calculate total maximum hours
        const totalMaxHrs = daysOfWeek
            .map(day => parseInt(modal[day + 'Max'], 10) || 0)
            .reduce((acc, curr) => acc + curr, 0);
        return { totalMinHrs, totalMaxHrs };
    };
    const { totalMinHrs, totalMaxHrs } = TotalMaxAndMin();
    // 24 hour validation for main
    const handle24HoursValidationMain = async () => {
        for (let key in mainAuthorizationModal) {
            let dayField = false
            if (mainAuthorizationModal.isScheduleDaily === true) {
                let dayField1 = daysOfWeek.some(day => key === `${day}Min` || key === `${day}Max`);
                if (dayField1) {
                    if (!isNull(mainAuthorizationModal[key])) {
                        return 'Clear Floating Values'
                    }
                } else {
                    dayField = daysOfWeek.some(day => key === day);
                }
            } else {
                let dayField1 = daysOfWeek.some(day => key === day);
                if (dayField1) {
                    if (!isNull(mainAuthorizationModal[key])) {
                        return 'Clear Daily Values'
                    }
                } else {
                    dayField = daysOfWeek.some(day => key === `${day}Min` || key === `${day}Max`);
                }

            }
            if (dayField) {
                const numericValue = parseFloat(mainAuthorizationModal[key], 10);
                if (numericValue < 1 || numericValue > 24) {
                    return 'Please enter hours within the 1 to 24 range';
                }
            }
        }
    }
    //Load ProgramTypes
    const LoadProgrameTypeDD = (InsuranceID) => {
        if (isHomeCareCheck === 'true') {
            ServerRequestProtected(API_URL_FEE + "/GetProgramType", 'post', {
                "TableName": enumUtil.enumAPITableName.FeeSetupCounty,
                "ID": InsuranceID + ""
            }).then((response) => {
                setProgramTypeDD(response)

                if (AuthorizationID === 0 && response.length === 1) {
                    setmainAuthorizationModal({ ...mainAuthorizationModal, ProviderFeeScheduleID: "", InsuranceType: response[1].value })
                }
                // setmainAuthorizationModal({...mainAuthorizationModal, ProviderFeeScheduleID: ""})
            }).catch((error) => {
                setProgramTypeDD([])
            })
        }

    }
    const handleCreateDD = (value) => {
        let data = OverallDD.filter((item) => item.InsuranceType === value);
        let obj = { value: '-1', display: 'Select Type' }
        data.unshift(obj)
        setCountyDD(data);
        if (data.length === 2) {
            return data
        } else {
            return data
        }
    }
    //Load Counties
    const LoadCounties = (insuranceid, cptid, type, selectedData) => {

        let modal = { ...mainAuthorizationModal };
        let SaveModal = { ...AuthorizationSaveUpdateModal }
        modal['ProcedureCode'] = selectedData.display
        modal['ProcedureCodeID'] = selectedData.display
        SaveModal['ProcedureCode'] = selectedData.display + "";
        SaveModal['ProcedureCodeID'] = selectedData.value + "";

        if (isHomeCareCheck === 'true') {
            ServerRequestProtected(API_URL_Search + "/Dropdown", 'post', {
                "TableName": enumUtil.enumAPITableName.ProgramType,
                "SearchCriteria": {
                    "PatientID": PateintIDR + "",
                    "ProcedureCodeID": !isNull(cptid) ? cptid + "" : '',
                    "InsuranceID": !isNull(insuranceid) ? insuranceid + "" : ''
                }
            }).then((response) => {
                setOverAllDD(response)
                if (type === 'ProcedureCode' && response.length > 0) {
                    if (ProgramTypeDD.length === 2) {
                        let data = response.filter(item => item.InsuranceType === ProgramTypeDD[1].value + "");
                        let defaultOption = { value: '-1', display: 'Select Type' };
                        data.unshift(defaultOption);
                        setCountyDD(data)
                        modal['InsuranceType'] = ProgramTypeDD[1].value
                        if (data.length === 2) {
                            modal['ProviderFeeScheduleID'] = data[1].display
                            modal['CountyAmount'] = data[1].Amount
                            SaveModal['ProviderFeeScheduleID'] = data[1].value + ""
                            setBillingEntityID(data[1].BillingEntityID + "")
                        } else {
                            const filteredCounties = data.filter((item) => {
                                return item.display.split(',').some(county => county.trim() === mainAuthorizationModal.PatientCounty);
                            });
                            if (filteredCounties.length > 0) {
                                let ptCounty = filteredCounties[0].display.split(',')
                                modal['CountyAmount'] = filteredCounties[0].Amount;
                                modal['ProviderFeeScheduleID'] = filteredCounties[0].display;
                                SaveModal['ProviderFeeScheduleID'] = filteredCounties[0].value + "";
                                setBillingEntityID(filteredCounties[0].BillingEntityID + "")
                            } else {
                                modal['CountyAmount'] = ''
                                modal['ProviderFeeScheduleID'] = ''
                                SaveModal['ProviderFeeScheduleID'] = ''
                                setBillingEntityID("")
                            }
                        }
                    } else {
                        modal['ProviderFeeScheduleID'] = ''
                        modal['InsuranceType'] = ''
                        modal['CountyAmount'] = ''
                        SaveModal['ProviderFeeScheduleID'] = ''
                        setBillingEntityID("")
                        setCountyDD([])
                    }
                }
            }).catch((error) => {
                // let modal = { ...mainAuthorizationModal };
                // let SaveModal = { ...AuthorizationSaveUpdateModal }
                modal['ProviderFeeScheduleID'] = ''
                modal['InsuranceType'] = ''
                modal['CountyAmount'] = ''
                SaveModal['ProviderFeeScheduleID'] = ''
                // setmainAuthorizationModal(modal)
                // setAuthorizationSaveUpdateModal(SaveModal)
                setBillingEntityID("")
                setOverAllDD([])
                setCountyDD([])
                // NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }

        setmainAuthorizationModal(modal)
        setAuthorizationSaveUpdateModal(SaveModal)
    }
    const LoadCountiesByWizard = (insuranceid, cptid) => {
        let modal = { ...mainAuthorizationModal };
        let SaveModal = { ...AuthorizationSaveUpdateModal }
        if (InsuranceListModal.length > 0) {
            if (!isNull(InsuranceListModal[0]?.value)) {
                modal.InsuranceID = InsuranceListModal[0]?.value + ""
                modal.PatientInsuranceID = InsuranceListModal[0].InsuranceName
                modal.ProcedureCode = authModal[0].ProcedureCodeID ? authModal[0].ProcedureCode : null
                modal.DiagnosisCode1 = authModal[0].DiagnosisCode1ID ? authModal[0].DiagnosisCode1 : null
                modal.DiagnosisCode2 = authModal[0].DiagnosisCode2ID ? authModal[0].DiagnosisCode2 : null
                modal.DiagnosisCode3 = authModal[0].DiagnosisCode3ID ? authModal[0].DiagnosisCode3 : null
                modal.DiagnosisCode4 = authModal[0].DiagnosisCode4ID ? authModal[0].DiagnosisCode4 : null
                modal.StartDate = authModal[0].StartDate
                modal.AdditionalCPTCode = authModal[0].AdditionalProcedureCodeID ? authModal[0].AdditionalProcedureCode : null
                LoadProgrameTypeDD(InsuranceListModal[0].value)
            }
        }
        SaveModal.isScheduleDaily = 'true'
        SaveModal.AuthorizationStatus = 'Active'
        SaveModal.PatientInsuranceID = props.PatientInsuranceID + ""
        SaveModal.ProcedureCode = authModal[0].ProcedureCodeID ? authModal[0].ProcedureCode : null
        SaveModal.ProcedureCodeID = authModal[0].ProcedureCodeID ? authModal[0].ProcedureCodeID + "" : null
        SaveModal.DiagnosisCode1 = authModal[0].DiagnosisCode1ID ? authModal[0].DiagnosisCode1 : null
        SaveModal.DiagnosisCode1ID = authModal[0].DiagnosisCode2ID ? authModal[0].DiagnosisCode2ID + "" : null
        SaveModal.DiagnosisCode2 = authModal[0].DiagnosisCode2ID ? authModal[0].DiagnosisCode2 : null
        SaveModal.DiagnosisCode2ID = authModal[0].DiagnosisCode2ID ? authModal[0].DiagnosisCode2ID + "" : null
        SaveModal.DiagnosisCode3 = authModal[0].DiagnosisCode3ID ? authModal[0].DiagnosisCode3 : null
        SaveModal.DiagnosisCode3ID = authModal[0].DiagnosisCode3ID ? authModal[0].DiagnosisCode3ID + "" : null
        SaveModal.DiagnosisCode4 = authModal[0].DiagnosisCode4ID ? authModal[0].DiagnosisCode4 : null
        SaveModal.DiagnosisCode4ID = authModal[0].DiagnosisCode4ID ? authModal[0].DiagnosisCode4ID + "" : null
        SaveModal.StartDate = authModal[0].StartDate
        SaveModal.AdditionalCPTCode = authModal[0].AdditionalProcedureCodeID ? authModal[0].AdditionalCPTCode : null
        SaveModal.AdditionalCPTCodeID = authModal[0].AdditionalProcedureCodeID ? authModal[0].AdditionalProcedureCodeID + "" : null
        if (isHomeCareCheck === 'true') {
            ServerRequestProtected(API_URL_Search + "/Dropdown", 'post', {
                "TableName": enumUtil.enumAPITableName.ProgramType,
                "SearchCriteria": {
                    "PatientID": PateintIDR + "",
                    "ProcedureCodeID": !isNull(cptid) ? cptid + "" : '',
                    "InsuranceID": !isNull(insuranceid) ? insuranceid + "" : ''
                }
            }).then((response) => {
                setOverAllDD(response)
                if (type === 'ProcedureCode' && response.length > 0) {
                    if (ProgramTypeDD.length === 2) {
                        let data = response.filter(item => item.InsuranceType === ProgramTypeDD[1].value + "");
                        let defaultOption = { value: '-1', display: 'Select Type' };
                        data.unshift(defaultOption);
                        setCountyDD(data)
                        modal['InsuranceType'] = ProgramTypeDD[1].value
                        if (data.length === 2) {
                            modal['ProviderFeeScheduleID'] = data[1].display
                            modal['CountyAmount'] = data[1].Amount
                            SaveModal['ProviderFeeScheduleID'] = data[1].value + ""
                            setBillingEntityID(data[1].BillingEntityID + "")
                        } else {
                            const filteredCounties = data.filter((item) => {
                                return item.display.split(',').some(county => county.trim() === mainAuthorizationModal.PatientCounty);
                            });
                            if (filteredCounties.length > 0) {
                                let ptCounty = filteredCounties[0].display.split(',')
                                modal['CountyAmount'] = filteredCounties[0].Amount;
                                modal['ProviderFeeScheduleID'] = filteredCounties[0].display;
                                SaveModal['ProviderFeeScheduleID'] = filteredCounties[0].value + "";
                                setBillingEntityID(filteredCounties[0].BillingEntityID + "")
                            } else {
                                modal['CountyAmount'] = ''
                                modal['ProviderFeeScheduleID'] = ''
                                SaveModal['ProviderFeeScheduleID'] = ''
                                setBillingEntityID("")
                            }
                        }
                    } else {
                        modal['ProviderFeeScheduleID'] = ''
                        modal['InsuranceType'] = ''
                        modal['CountyAmount'] = ''
                        SaveModal['ProviderFeeScheduleID'] = ''
                        setBillingEntityID("")
                        setCountyDD([])
                    }
                }
            }).catch((error) => {
                setOverAllDD([])
                setCountyDD([])
            })
        }
        // setOCRType(InsuranceListModal[0].AuthOCRType)
        setmainAuthorizationModal(modal)
        setAuthorizationSaveUpdateModal(SaveModal)
    }
    // find practice Data by id 
    useEffect(() => {
        if (props.AuthorizationID != null) {
            setAuthorizationID(props.AuthorizationID)
            setDel(true)
        } else {
            if (type === 'Wizard') {
                // if (InsuranceListModal.length > 0) {
                //     if (!isNull(InsuranceListModal[0]?.value)) {
                //         setmainAuthorizationModal({ ...mainAuthorizationModal, InsuranceID: InsuranceListModal[0]?.value + "", PatientInsuranceID: InsuranceListModal[0].InsuranceName, ProcedureCode: authModal[0].ProcedureCode, DiagnosisCode1: authModal[0].DiagnosisCode1, StartDate: authModal[0].StartDate })
                //         LoadProgrameTypeDD(InsuranceListModal[0].value)
                //     }
                // }
                // setAuthorizationSaveUpdateModal({ ...AuthorizationSaveUpdateModal, isScheduleDaily: 'true', AuthorizationStatus: 'Active', Frequency: 'Weekly', PatientInsuranceID: props.PatientInsuranceID + "", ProcedureCode: authModal[0].ProcedureCode, ProcedureCodeID: authModal[0].ProcedureCodeID + "", DiagnosisCode1: authModal[0].DiagnosisCode1, DiagnosisCode1ID: authModal[0].DiagnosisCode1, StartDate: authModal[0].StartDate })
                if (InsuranceListModal.length > 0) {
                    LoadCountiesByWizard(InsuranceListModal[0]?.value + "", authModal[0].ProcedureCodeID + "")

                }
                if (!onInsuranceSave) {
                    setAuthorizationID(0);
                    setDel(false)
                } else {
                    setDel(true)
                }
            } else {
                if (InsuranceListModal.length > 0) {
                    if (!isNull(InsuranceListModal[0]?.value)) {
                        setmainAuthorizationModal({ ...mainAuthorizationModal, InsuranceID: InsuranceListModal[0]?.value + "", PatientInsuranceID: InsuranceListModal[0].InsuranceName })
                        setOCRType(InsuranceListModal[0].AuthOCRType)
                        LoadProgrameTypeDD(InsuranceListModal[0].value)
                    }
                }
                setAuthorizationSaveUpdateModal({ ...AuthorizationSaveUpdateModal, isScheduleDaily: 'true', AuthorizationStatus: 'Active', Frequency: 'Weekly', PatientInsuranceID: props.PatientInsuranceID + "" })
                if (!onInsuranceSave) {
                    setAuthorizationID(0);
                    setDel(false)
                } else {
                    setDel(true)
                }
            }

        }
    }, [InsuranceListModal])
    useEffect(() => {
        setIs(true)
        if (!isNull(AuthorizationID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/PatientAuthByID", 'post', {
                "ID": AuthorizationID,
                "TableName": enumUtil.enumAPITableName.PatientAuthorization
            }).then((response) => {
                setIsLoading(false)
                // response.State = DropdownValueHandler(States, response.State)

                setmainAuthorizationModal({
                    ...response.PatientAuthorization,
                    ProviderFeeScheduleID: response.PatientAuthorization.CountyName,
                    InsuranceID: response.PatientAuthorization.InsuranceID + "",
                    PatientInsuranceID: response.PatientAuthorization.InsuranceName,
                    StartDate: !isNull(response.PatientAuthorization.StartDate) ? FormatDate(response.PatientAuthorization.StartDate) : null,
                    EndDate: !isNull(response.PatientAuthorization.EndDate) ? FormatDate(response.PatientAuthorization.EndDate) : null
                })

                if (previousAuthorizationNumber === "") {
                    setPreviousAuthorizationNumber(response.PatientAuthorization.AuthorizationNumber);
                }
                setBillingEntityID(response.PatientAuthorization.BillingEntityID + "")
                LoadProgrameTypeDD(response.PatientAuthorization.InsuranceID)
                ServerRequestProtected(API_URL_Search + "/Dropdown", 'post', {
                    "TableName": enumUtil.enumAPITableName.ProgramType,
                    "SearchCriteria": {
                        "PatientID": PateintIDR + "",
                        "ProcedureCodeID": response.PatientAuthorization.ProcedureCodeID,
                        "InsuranceID": response.PatientAuthorization.InsuranceID
                    }
                }).then((resp) => {
                    setOverAllDD(resp)
                    let data = resp.filter((item) => item.InsuranceType === response.PatientAuthorization.InsuranceType);
                    let obj = { value: '-1', display: 'Select Type' }
                    data.unshift(obj)
                    setCountyDD(data);
                }).catch((error) => {
                    // NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                    setOverAllDD([])
                    setCountyDD([])
                })

                setAdditionalCPT(response.PatientAuthorization?.AdditionalCPTCodeID);
                setclaimCounts(response.PatientAuthorization?.ClaimCount)
                setsplitShiftData(response.Shift)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }, [AuthorizationID])
    // handle change for Practice 
    useEffect(() => {
        GetBillingDropDown()
    }, [])

    const handleAuthorizationChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase();
        }
        let modal = { ...mainAuthorizationModal };
        let saveModal = { ...AuthorizationSaveUpdateModal };
        if (name === 'isLiveIn' || name === "isSplitShift") {
            if (name === 'isSplitShift') {
                if (!modal[name]) {
                    handleAddNewShift()
                } else {
                    setsplitShiftData([])
                }
            }
            modal[name] = !modal[name];
        } else if (name === "isScheduleFloating" || name === "isScheduleDaily") {
            if (name === "isScheduleFloating") {
                modal["isScheduleFloating"] = true;
                modal["isScheduleDaily"] = false;
                modal['isSplitShift'] = false
            } else {
                modal["isScheduleFloating"] = false;
                modal["isScheduleDaily"] = true;
            }
        } else if (name === 'IsTranspotation') {
            modal[name] = !modal[name]
        } else {
            modal[name] = value;
        }

        // Update saveModal for related properties
        for (var property in Authorization_Modal) {
            if (name === property) {
                if (name === 'isLiveIn' || name === "isSplitShift" || name === 'IsTranspotation') {
                    saveModal[name] = modal[name] + "";
                } else if (name === "isScheduleFloating" || name === "isScheduleDaily") {
                    if (name === "isScheduleFloating") {
                        saveModal["isScheduleFloating"] = 'true'
                        saveModal["isScheduleDaily"] = 'false'
                        saveModal["isSplitShift"] = 'false'
                    } else {
                        saveModal["isScheduleFloating"] = 'false'
                        saveModal["isScheduleDaily"] = 'true'
                    }
                } else {
                    saveModal[name] = value;
                }
            }
        }
        console.log(modal, saveModal);
        
        setmainAuthorizationModal(modal);
        setAuthorizationSaveUpdateModal(saveModal);
    };
    const CalculatePerunitHours = (val) => {
        const totalHours = val / 4;
        const hours = Math.floor(totalHours);

        // Get the remaining minutes by multiplying the decimal part of hours by 60
        const minutes = Math.round((totalHours - hours) * 60);

        // Format the result as "XH YM"
        return `${hours}H ${minutes}M`;
    }
    const handleAuthorizationChange_ = (e) => {
        setIs(false)
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase();
        }
        let modal = { ...mainAuthorizationModal };
        let saveModal = { ...AuthorizationSaveUpdateModal };
        if (name === 'InsuranceType') {
         
        }
        if (name === 'ProviderFeeScheduleID') {
            const selectedOption = e.target.options[e.target.selectedIndex];
            const amount = selectedOption.getAttribute('data-amount');
            const BillingEntity = selectedOption.getAttribute('data-BillingEntity');
            setBillingEntityID(BillingEntity)
            modal['CountyAmount'] = amount;
            // saveModal['CountyAmount'] = !isNull(amount) ? amount : '0';
        }
        modal[name] = value;
        // Update saveModal for related properties
        if (name === 'ProviderFeeScheduleID') {
            for (var property in Authorization_Modal) {
                if (name === property) {
                    saveModal[name] = value;
                }
            }
        }
        setmainAuthorizationModal(modal);
        setAuthorizationSaveUpdateModal(saveModal);
    };
    const handleDropdwonChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainAuthorizationModal };
        let saveModal = { ...AuthorizationSaveUpdateModal };
        modal[name] = value
        setmainAuthorizationModal(modal)
        for (var property in Authorization_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setAuthorizationSaveUpdateModal(saveModal)
    }
    const AuthorizationFileValidation = async () => {
        let validationModal = {
            UploadedFile: FormValidator(mainAuthorizationModal.FileName, enumUtil?.enumValidationType?.Required, 'File'),

        }
        AuthFile_Val_Modal = validationModal
        setAuthFileValidation(validationModal);
    }
    const AuthorizationValidation = async () => {
        let ValidationModal = {
            InusranceIDVal: FormValidator(
                mainAuthorizationModal.PatientInsuranceID,
                enumUtil.enumValidationType.Required,
                'Insurance Name',
            ),
            ProcedureCodeVal: FormValidator(
                mainAuthorizationModal.ProcedureCode,
                enumUtil.enumValidationType.Required,
                'CPT Code',
            ),
            AuthorizationNumberVal: FormValidator(
                mainAuthorizationModal.AuthorizationNumber,
                enumUtil.enumValidationType.Required,
                'Authorization Number',
            ),
            UnitsFrequencyVal: FormValidator(
                mainAuthorizationModal.UnitsFrequency,
                enumUtil.enumValidationType.Required,
                'Unit(s) Per Frequency',
            ),
            AuthorizedUnitsVal: FormValidator(
                mainAuthorizationModal.AuthorizeUnits,
                enumUtil.enumValidationType.Required,
                'Authorize Units',
            ),
            StartDateval: FormValidator(
                mainAuthorizationModal.StartDate,
                enumUtil.enumValidationType.Required,
                "Start Date"
            ),
            EndDateVal: FormValidator(
                mainAuthorizationModal.EndDate,
                enumUtil.enumValidationType.Required,
                "End Date"
            )
        }
        await setAuthorizationValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveAuthorization = async () => {
        await validateDates()
        await AuthorizationValidation()
        let validation1 = FormValidator([valoModalDate], enumUtil.enumValidationType.NullCheck)
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        let HoursValidation
        if (BillingEntityID === '2') {
            HoursValidation = await handle24HoursValidationMain()
        }
        if (validation || validation1) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else if (!isNull(HoursValidation)) {
            // else if (isNull(mainAuthorizationModal.CountyAmount)) {
            //     NotificationHandler("Please Correct Fee Setup, county amount is $0", enumUtil.enumtoaster.error)
            // } 
            NotificationHandler(HoursValidation, enumUtil.enumtoaster.error)
        }
        else {
            let totalFrequencyCheck = ""
            const totalHour = splitShiftData && splitShiftData.reduce((total, record) => {
                if (record) {
                    return total + calculateTotalHours(record);
                }
                return total;
            }, 0);
            totalFrequencyCheck = totalHour + (totalHours || 0);
            if (mainAuthorizationModal.UnitsFrequency.toString() > mainAuthorizationModal.AuthorizeUnits.toString) {
                NotificationHandler('Units Per Frequency cannot be greater than Authorized Units !', enumUtil.enumtoaster.error)
            } else if (mainAuthorizationModal.isScheduleDaily === true && mainAuthorizationModal.UnitsFrequency - "" < totalFrequencyCheck - "") {
                NotificationHandler('Total hours must be less than from Unit(s) Per Frequency !', enumUtil.enumtoaster.error)
            } else {
                let updatedSplitShiftData = splitShiftData.map(record => {
                    let checksplitdata = { ...record };
                    for (let key in checksplitdata) {
                        if (!checksplitdata[key] || checksplitdata[key] === '') {
                            checksplitdata[key] = null;
                        }
                    }
                    return checksplitdata;
                });
                for (let key in AuthorizationSaveUpdateModal) {
                    let dayField = false;
                    dayField = daysOfWeek.some(day => key === day || key === `${day}Min` || key === `${day}Max`);
                    if (dayField && AuthorizationSaveUpdateModal[key] === "") {
                        AuthorizationSaveUpdateModal[key] = '-99';
                    }
                }

                // AuthorizationSaveUpdateModal["PatientID"] = PateintIDR + ""
                // AuthorizationSaveUpdateModal["PatientInsuranceID"] = props.PatientInsuranceID + "";
                let saveModal = {
                    TableName: enumUtil.enumAPITableName.PatientAuthorization,
                    ID: AuthorizationID + "",
                    data: { ...AuthorizationSaveUpdateModal, PatientID: PateintIDR + "" },
                    ListOfData: updatedSplitShiftData
                }
                setIsLoading(true)
                ServerRequestProtected(API_URL + "/SavePatientAuthorization", 'post', saveModal).then((response) => {
                    setIsLoading(false)
                    if (type === "Wizard") {
                        UpdateFiledStatus()
                    }
                    if (!isNull(response.id)) {
                        setAuthorizationSaveUpdateModal(response.AuthorizationNumber)
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setAuthorizationID(response.id);
                        setOnInsuranceSave(true);
                    }
                    let NewAuthorizationNumber = AuthorizationSaveUpdateModal?.AuthorizationNumber;
                    setNewAuthorizationNumber(NewAuthorizationNumber)
                    if (AuthorizationID !== 0) {
                        if (claimCounts > 0 && NewAuthorizationNumber && NewAuthorizationNumber !== previousAuthorizationNumber) {
                            setUpdateAuthorizationNumber(true);
                            return;
                        }
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
            }
        }
    }
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    const SetAuthorizationName = () => {
        if (mainAuthorizationModal.InsuranceName) {
            return (
                <p className="heading sm">{mainAuthorizationModal.InsuranceName}</p>
            )
        } else {
            return (
                <p className="heading sm">Add Authorization</p>
            )
        }
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="bi bi-trash-fill"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.PatientAuthorization} ID={AuthorizationID} onClose={onDeleteInsurance} />
    }
    const handleAuditModal = () => { setisOpenAudit(true) }
    const onCloseAudit = () => { setisOpenAudit(false) }
    const onCloseNpi = () => { setIsOpenRegistry(false) }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={AuthorizationID + ""} TableName={enumUtil.enumAPITableName.PatientAuthorization} />
    }

    let PopupScreen = "";
    if (isOpenRegistry) {
        console.log('here if openrigistry is true');

        PopupScreen = <Pdfdetail isOpenRegistry={isOpenRegistry} NpiNumber={NpiRegistryNumber} OCRFile={AuthorizationSaveUpdateModal?.AuthorizationDocument} ApplyFileChanges={ApplyFileChanges} onClosee={CloseRegistry} onCloseNpi={onCloseNpi} OCRType={OCRType} AuthMainModal={mainAuthorizationModal} LoadCounties={(...params) => LoadCounties(mainAuthorizationModal.InsuranceID, ...params)} ClassName='npi-panel npi-open npi_detail_popup' />
    }
    console.log(isOpenRegistry, "isOpenRegistry", PopupScreen);

    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainAuthorizationModal };
        let saveModal = { ...AuthorizationSaveUpdateModal }
        modal[type] = FormatedDate
        setmainAuthorizationModal(modal)
        for (var property in Authorization_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setAuthorizationSaveUpdateModal(saveModal)
    }
    const validateDates = async () => {
        let ValidationModal = {
            DateVal: DateValidator(
                mainAuthorizationModal.StartDate,
                mainAuthorizationModal.EndDate,
                enumUtil.enumValidationType.StartEndDate,
                'Date',
            ),
        }
        await setError(ValidationModal)
        valoModalDate = ValidationModal
    };
    const [billingEntityOption, setBillingEntityOption] = useState([])
    const GetBillingDropDown = () => {
        ServerRequestProtected(API_URL_Search + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.BillingEntity
        }).then((response) => {
            setBillingEntityOption(response)
        }).catch((error) => {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }
    const handleBillingEntityValue = (id) => {
        let arr = billingEntityOption.filter(item => item.value === id)[0]?.display
        return arr
    }
    const handleSelectedData = async (selectedData, name, type) => {
        setIs(true)
        let saveModal = { ...AuthorizationSaveUpdateModal };
        let modal = { ...mainAuthorizationModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'PatientInsuranceID') {
                modal[name] = selectedData.InsuranceName
                modal['InsuranceID'] = selectedData.value + ""
                saveModal[name] = selectedData.PatientInsuranceID + "";
                let cptt = ''
                if (!isNull(modal.ProcedureCodeID)) {
                    cptt = modal.ProcedureCodeID
                }
                setOCRType(selectedData?.AuthOCRType)
                setCountyDD([])
                LoadCounties(selectedData.value, cptt + "", null, selectedData)
                LoadProgrameTypeDD(selectedData.value)
            } else if (name === 'ProviderFeeScheduleID') {
                modal[name] = selectedData.display
                modal['CountyAmount'] = selectedData.Amount
                setBillingEntityID(!isNull(selectedData.BillingEntityID) ? selectedData.BillingEntityID + "" : '')
                saveModal[name] = selectedData.value + "";
                // const selectedOption = e.target.options[e.target.selectedIndex];
                // const amount = selectedOption.getAttribute('data-amount');
                // const BillingEntity = selectedOption.getAttribute('data-BillingEntity');
                // setBillingEntityID(BillingEntity)
                // modal['CountyAmount'] = amount;
                // saveModal['CountyAmount'] = !isNull(amount) ? amount : '0';
            } else if (name === 'InsuranceType') {
                let firstCounty = handleCreateDD(selectedData.value)
                if (firstCounty.length === 2) {
                    modal['CountyAmount'] = firstCounty[1].Amount;
                    modal['ProviderFeeScheduleID'] = firstCounty[1].display;
                    saveModal['ProviderFeeScheduleID'] = firstCounty[1].value + '';
                    setBillingEntityID(firstCounty[1].BillingEntityID + "")
                } else {
                    const filteredCounties = firstCounty.filter((item) => {
                        return item.display.split(',').some(county => county.trim() === mainAuthorizationModal.PatientCounty);
                    });
                    if (filteredCounties.length > 0) {
                        let ptCounty = filteredCounties[0].display.split(',')
                        modal['CountyAmount'] = filteredCounties[0].Amount;
                        modal['ProviderFeeScheduleID'] = filteredCounties[0].display;
                        saveModal['ProviderFeeScheduleID'] = filteredCounties[0].value + "";
                        setBillingEntityID(filteredCounties[0].BillingEntityID + "")

                    } else {
                        modal['CountyAmount'] = ''
                        modal['ProviderFeeScheduleID'] = ''
                        saveModal['ProviderFeeScheduleID'] = ''
                        setBillingEntityID('')
                    }
                }
                modal[name] = selectedData.display
                saveModal[name] = selectedData.value + "";
            } else {
                modal[name] = selectedData.display
                saveModal[name] = selectedData.value + "";
            }

        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'DiagnosisCode1') {
                modal[name] = selectedData.display
                saveModal[name] = selectedData.display + "";
                saveModal['DiagnosisCode1ID'] = selectedData.value + "";
            } else if (name === 'DiagnosisCode3') {
                modal[name] = selectedData.display
                saveModal[name] = selectedData.display + "";
                saveModal['DiagnosisCode3ID'] = selectedData.value + "";
            } else if (name === 'DiagnosisCode2') {
                modal[name] = selectedData.display
                saveModal[name] = selectedData.display + "";
                saveModal['DiagnosisCode2ID'] = selectedData.value + "";
            } else if (name === 'DiagnosisCode4') {
                modal[name] = selectedData.display
                saveModal[name] = selectedData.display + "";
                saveModal['DiagnosisCode4ID'] = selectedData.value + "";
            }
            else if (name === 'ProcedureCode') {
                // modal[name] = selectedData.display
                // modal['ProcedureCodeID'] = selectedData.display
                // AuthorizationSaveUpdateModal[name] = selectedData.display + "";
                // AuthorizationSaveUpdateModal['ProcedureCodeID'] = selectedData.value + "";
                return LoadCounties(modal.InsuranceID, selectedData.value + "", 'ProcedureCode', selectedData)
            }
            else if (name === 'AdditionalCPTCode') {
                modal[name] = selectedData.display
                saveModal[name] = selectedData.display + "";
                saveModal['AdditionalCPTCodeID'] = selectedData.value + "";
            }
        } else {
            modal[name] = ''
            saveModal[name] = ''
        }
        setmainAuthorizationModal(modal)
        setAuthorizationSaveUpdateModal(saveModal)
        return selectedData
    }
    const handleSelectDiagnosisData = (selectedData, name, type, isRecICD) => {
        let data
        if (isRecICD === true) {
            data = { value: selectedData[0].DiagnosisCodeID, display: selectedData[0].DiagnosisCode }
        } else {
            data = selectedData
        }
        let modal = { ...mainAuthorizationModal };
        if (type === 'client' && !isNull(data)) {
            if (name === 'BillingProviderID') {
                modal[name] = data.display
                AuthorizationSaveUpdateModal[name] = data.value;
            }
        } else if (type === 'server' && !isNull(data)) {
            // if (name === 'DiagnosisCode1') {
            modal[name] = data.display
            AuthorizationSaveUpdateModal[name] = data.display + "";
            AuthorizationSaveUpdateModal[name + 'ID'] = data.value + "";
            // } else if (name === 'DiagnosisCode2') {
            //     modal[name] = data.display
            //     AuthorizationSaveUpdateModal[name] = data.display + "";
            //     AuthorizationSaveUpdateModal[name + 'ID'] = data.value + "";
            // }else if (name === 'DiagnosisCode3') {
            //     modal[name] = selectedData.display
            //     AuthorizationSaveUpdateModal[name] = selectedData.display + "";
            //     AuthorizationSaveUpdateModal['DiagnosisCode3ID'] = selectedData.value + "";
            // } else if (name === 'DiagnosisCode4') {
            //     modal[name] = selectedData.display
            //     AuthorizationSaveUpdateModal[name] = selectedData.display + "";
            //     AuthorizationSaveUpdateModal['DiagnosisCode4ID'] = selectedData.value + "";
            // } 
        } else {
            modal[name] = ''
            AuthorizationSaveUpdateModal[name] = ''
        }
        setmainAuthorizationModal(modal)
        // setICDvalidationModal(myVal)
        let valList = []
        const variableName = name
        const lastIndex = variableName.lastIndexOf('Code');
        let codeNumber
        if (lastIndex !== -1) {
            codeNumber = variableName.slice(3, lastIndex);
        } else {
            console.log('Code not found in the variable name');
        }

        return selectedData
    }
    const [isFileChanged, setIsFileChanged] = useState(false)

    const handleImageChange = (e) => {
        setIsFileChanged(true)
        const { name, files } = e.target;
        const file = files[0];
        console.log("file", file)
        const modalCopy = { ...mainAuthorizationModal };
        const saveModalCopy = { ...AuthorizationSaveUpdateModal };

        if (name === 'AuthorizationDocument') {
            modalCopy['FileName'] = file.name;
            saveModalCopy['FileName'] = file.name;
        }

        const fileType = file.type.substring(0, 5);

        // if (fileType === 'image') {
        const reader = new FileReader();

        reader.onloadend = (event) => {
            const value = reader.result.toString();
            modalCopy[name] = value;
            for (const property in modalCopy) {
                if (name === property) {
                    saveModalCopy[name] = event.target.result.split("base64,")[1];
                }
            }

        };

        reader.readAsDataURL(file);
        // }
        setmainAuthorizationModal(modalCopy);
        setAuthorizationSaveUpdateModal(saveModalCopy);

    }
    const ViewPdf = (data) => {
        setPdfFile(null)
        setTxtFile(null)
        setImgFile(null)
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": mainAuthorizationModal.AuthorizationDocument
        }, 'Download').then((response) => {
            setIsLoading(false)
            if (response.type === 'application/txt') {
                const blob = response;
                const reader = new FileReader();
                reader.onload = () => {
                    const content = reader.result;
                    setTxtFile(content);
                };
                reader.readAsText(blob, 'utf-8');
            } else if (response.type === 'application/png' || response.type === 'application/jpg' || response.type === 'application/jepg') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);
                setImgFile(objectURL)
            } else if (response.type === 'application/tiff') {

            }
            else {
                let file = new Blob([response]);
                const fileUrl = URL.createObjectURL(file);
                setPdfFile(fileUrl)
            }
            setModalActive(true)
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
        })
    }
    const handleRemoveImage = (type) => {
        if (type === 'AuthorizationDocument') {
            setmainAuthorizationModal({
                ...mainAuthorizationModal,
                AuthorizationDocument: null,
                FileName: '',
            });
            setAuthorizationSaveUpdateModal({
                ...AuthorizationSaveUpdateModal,
                AuthorizationDocument: null,
                FileName: '',
            });
        }
    }
    const DownloadFile = () => {
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": mainAuthorizationModal.AuthorizationDocument
        }, "Download",)
            .then((response) => {
                setIsLoading(false)
                let blob = new Blob([response]);
                saveAs(blob, mainAuthorizationModal.FileName);
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
    }
    const GetDataFromFile = (fileResponse) => {

        let modal = { ...mainAuthorizationModal };
        let saveModal = { ...AuthorizationSaveUpdateModal };



    }
    const handleOpenCPTCode = (name) => {
        setCurIndex(name)
        setisOpenCPT(true)
    }
    const onCloseCPT = () => {
        setisOpenCPT(false)
        setSelectedRows(new Set())
    }
    const handleOpenICD = (name) => {
        setcurSelectedICD(name)
        setisOpenICDSearch(true)
    }
    const onCloseICD = () => {
        setisOpenICDSearch(false)
    }
    const handleDiagnosisChange = (e) => {
        // setClaimInfoVal(ValidationModal)
        setIs(false)
        let { name, value } = e.target
        let modal = { ...mainAuthorizationModal }
        let saveModal = { ...AuthorizationSaveUpdateModal }
        modal[name] = value
        setmainAuthorizationModal(modal)
        for (var property in Authorization_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setmainAuthorizationModal(modal)
        if (name === 'ProcedureCode' || name === 'AdditionalCPTCode') {
            setcptBody({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": value })

        } else if (name === 'DiagnosisCode1' || name === 'DiagnosisCode2' || name === 'DiagnosisCode3' || name === 'DiagnosisCode4') {
            setIcdBody({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": value })

        }
    }
    const handleServiceLineChange = (e, id, index, type) => {
        // setIs(false);
        setIs(true)
        let { name, value } = e.target
        let modal = { ...mainAuthorizationModal }
        modal[name] = value
        let saveModal = { ...AuthorizationSaveUpdateModal }
        modal[name] = value
        setmainAuthorizationModal(modal)
        for (var property in Authorization_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setAuthorizationSaveUpdateModal(saveModal)
        setIcdBody({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": value })
    };
    const handleSelecCPT = (cptCode, method) => {
        if (!isNull(cptCode)) {
            if (method === 'CPT') {
                let arr = [...cptCode];
                let data = arr.filter((item) => {
                    return item.ProcedureCodeID + "" === selectedClaimId + "";
                });

                // Assuming selectedClaimId and curSelectedICD are defined somewhere
                if (curIndex === "AdditionalCPTCode") {
                    let modal = { ...mainAuthorizationModal }
                    let saveModal = { ...AuthorizationSaveUpdateModal }
                    modal['AdditionalCPTCode'] = data[0].ProcedureCode
                    saveModal['AdditionalCPTCode'] = data[0].ProcedureCode
                    saveModal['AdditionalCPTCodeID'] = data[0].ProcedureCodeID
                    setmainAuthorizationModal(modal)
                    setAuthorizationSaveUpdateModal(saveModal)
                    // handleServiceLineChange({ target: { name: 'AdditionalCPTCode', value: data[0].ProcedureCode } }, curSelectedICD, 'server', true);
                } else {
                    handleServiceLineChange({ target: { name: 'ProcedureCode', value: data[0].ProcedureCode } }, curSelectedICD, 'server', true);
                    let selectedData = { value: data[0].ProcedureCodeID, display: data[0].ProcedureCode }
                    LoadCounties(mainAuthorizationModal.InsuranceID, data[0].ProcedureCodeID + "", 'ProcedureCode', selectedData)
                }
            } else {
                let arr = [...cptCode];
                let data = arr.filter((item) => {
                    return item.ProcedureMacroID + "" === selectedClaimId + "";
                });

                // Assuming curIndex is defined somewhere
                // handleSuperSearchList(data, curIndex, 'ProcedureCode', true, method);
            }

            onCloseCPT();
        }
    };
    const onRowSelection = (listOfIds) => {
        const arrayOfIds = Array.from(listOfIds); // Convert the Set to an array
        const lastSelectedId = arrayOfIds[arrayOfIds.length - 1]; // Get the last element in the array
        setSelectedRows(new Set([lastSelectedId])); // Set the last selected ID as a new Set
        setSelectedClaimID(lastSelectedId);
    }
    const onRowSelectionPR = (listOfIds) => {
        const arrayOfIds = Array.from(listOfIds); // Convert the Set to an array
        const lastSelectedId = arrayOfIds[arrayOfIds.length - 1]; // Get the last element in the array
        setSelectedRows(new Set([lastSelectedId])); // Set the last selected ID as a new Set
        setSelectedClaimID(lastSelectedId);
    }
    const rowKeyGetter = (row) => {
        return row.DiagnosisCodeID;
    }
    const rowKeyGetterPR = (row) => {
        return row.ProcedureCodeID;
    }
    const handleSelectDiagnosis = (diagnosisCode) => {

        if (!isNull(diagnosisCode)) {
            let arr = [...diagnosisCode]
            let data = arr.filter((item) => {
                return item.DiagnosisCodeID + "" === selectedClaimId + ""
            })
            handleSelectDiagnosisData(data, curSelectedICD, 'server', true)
            onCloseICD()
        }
    }
    const handleNpiRegistry = async () => {
        await AuthorizationFileValidation();
        let validation = FormValidator([AuthFile_Val_Modal], enumUtil.enumValidationType.NullCheck)

        if (validation) {
            return
        }

        setIsOpenRegistry(true);
        setIsLoading(false);
        onCloseProocedNpi();
    }
    let ICDpopup = '';
    if (isOpenICDSearch) {
        ICDpopup = <DiagnosisSearch isOpenICDSearch={isOpenICDSearch} onCloseICD={onCloseICD} handleSelectDiagnosis={handleSelectDiagnosis} onRowSelection={onRowSelection} rowKeyGetter={rowKeyGetter} selectedRows={selectedRows} />
    }
    let ProcedureSerachPopup = '';
    if (isOpenCPT) {
        ProcedureSerachPopup = <ProcedureSearch isOpenCPT={isOpenCPT} onCloseCPT={onCloseCPT} handleSelecCPT={handleSelecCPT} onRowSelection={onRowSelectionPR} rowKeyGetter={rowKeyGetterPR} selectedRows={selectedRows} options={false} />
    }
    const handleAutorized = () => {
        setisOpenAuthorized(true)
        setUpdateAuthorizationNumber(false)
    }
    const handleAutorizedClose = () => {
        setUpdateAuthorizationNumber(false);
        setPreviousAuthorizationNumber(mainAuthorizationModal?.AuthorizationNumber);
    }
    const onCloseAuthorized = () => {

        setisOpenAuthorized(false)
        setPreviousAuthorizationNumber(mainAuthorizationModal?.AuthorizationNumber);

    }
    let AuthrizedPopup = "";
    if (isOpenAuthorized) {
        AuthrizedPopup = <AuthorizedUpdatePopup isOpenAuthorized={isOpenAuthorized} onClose={onCloseAuthorized} PrevAuthorization={previousAuthorizationNumber} UpdateAuthorization={NewAuthorizationNumber} AuthorizationID={AuthorizationID} AdditionalCPT={AdditionalCPT} />
    }
    const AddnewAuth = () => {
        return (
            <>
                <div className="row row-gap-8">
                    <div className="col-md-6 mb-1 ar-multiple-br ">
                        {/* <div className={AuthorizationValidationModal.InusranceIDVal ? 'form-group input error' : 'form-group input'}> */}
                        <div className='input form-group mb-0'>
                            <label htmlFor="PatientInsuranceID">Payer<span className='req'>*</span></label>
                            <SuperSearchList
                                type="client"
                                id='PatientInsuranceID'
                                name='PatientInsuranceID'
                                searchValue={mainAuthorizationModal.PatientInsuranceID}
                                data={InsuranceListModal}
                                onChange={handleDropdwonChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                inputError={AuthorizationValidationModal.InusranceIDVal}
                            />
                            {/* </div> */}
                            {AuthorizationValidationModal.InusranceIDVal}
                        </div>
                    </div>
                    <div className="col-md-6 mb-1">
                        <div className="form-group input">
                            <label htmlFor="AuthorizationNumber">Authorization #<span className='req'>*</span></label>
                            {/* <div className={AuthorizationValidationModal.AuthorizationNumberVal ? 'form-group input error' : 'input form-group mb-0'}> */}
                            <input type="text"
                                className='form-control'
                                name="AuthorizationNumber"
                                id="AuthorizationNumber"
                                maxLength={50}
                                autoComplete="off"
                                value={mainAuthorizationModal.AuthorizationNumber}
                                onChange={handleAuthorizationChange}
                            />
                            {AuthorizationValidationModal.AuthorizationNumberVal}
                            {/* </div> */}
                        </div>
                    </div>
                    <div className='col-md-3 mb-1'>
                        {/* <div className={error.DateVal || AuthorizationValidationModal.StartDateval ? 'form-group input error' : 'input form-group'}> */}
                        <DatePicker
                            label={<span> Start Date <span className='req'>*</span> </span>}
                            className='mb-0'
                            value={mainAuthorizationModal.StartDate}
                            handleCalendarChangefunc={date => handleCalendarChange(date, 'StartDate')}
                        />
                        {/* </div> */}
                        {error.DateVal || AuthorizationValidationModal.StartDateval}
                    </div>
                    <div className="col-md-3 mb-1">
                        {/* <div className={error.DateVal || AuthorizationValidationModal.EndDateVal ? 'form-group input error' : 'input form-group'}> */}
                        <DatePicker
                            label={<span> End Date <span className='req'>*</span> </span>}
                            className='mb-0'
                            value={mainAuthorizationModal.EndDate}
                            handleCalendarChangefunc={date => handleCalendarChange(date, 'EndDate')}
                            portalId="root-portal"
                        />
                        {/* </div> */}
                        {error.DateVal || AuthorizationValidationModal.EndDateVal}
                    </div>
                    <div className="col-md-3 ">
                        <div className='form-group input'>
                            <div className="d-flex justify-content-between">
                                {/* {!isNull(mainAuthorizationModal.DiagnosisCode1) ?
                                   <> { icd1 }</>
                                    : */}
                                {/* <> */}
                                <label>ICD1</label>
                                <div className="label-head" onClick={() => handleAddNewICD('', 'DiagnosisCode1')}>
                                    <button class="btn-icon-circle btn-xs">
                                        <i className='icon-plus-icon'></i>
                                    </button>
                                </div>
                                {/* </> */}

                                {/* } */}
                                {isReadOnly ? null : <i className='icon-Clip-path-group' onClick={() => handleOpenICD('DiagnosisCode1')}></i>}
                            </div>
                            <SuperICDandCPTSearch
                                type='server'
                                customData={RecentICDs}
                                PatDxData={[]}
                                id='Dx'
                                name='DiagnosisCode1'
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainAuthorizationModal.DiagnosisCode1}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display', },
                                    { columName: 'Description', bindingValue: 'Description', },
                                ]}
                                ApiLink={API_URL_Claim + "/ICDInstantSearch"}
                                method='post'
                                postBody={icdBody}
                                disabled={true}
                                // placeholder={""}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // inputError={icd1Val}
                                isItemSelected={!isNull(mainAuthorizationModal.DiagnosisCode1) ? true : false}
                                handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                showPatDx={false}
                                isReadOnly={isReadOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className='form-group input'>
                            <div className="d-flex justify-content-between">
                                {!isNull(mainAuthorizationModal.DiagnosisCode2) ?
                                    <>
                                        {icd2}
                                    </> :
                                    <label>ICD 2</label>
                                }
                                {isReadOnly ? null : <i className='icon-Clip-path-group' onClick={() => handleOpenICD('DiagnosisCode2')}></i>}
                            </div>
                            <SuperICDandCPTSearch
                                type='server'
                                customData={RecentICDs}
                                PatDxData={[]}
                                id='Dx'
                                name='DiagnosisCode2'
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainAuthorizationModal.DiagnosisCode2}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display', },
                                    { columName: 'Description', bindingValue: 'Description', },
                                ]}
                                ApiLink={API_URL_Claim + "/ICDInstantSearch"}
                                method='post'
                                postBody={icdBody}
                                disabled={true}
                                // placeholder={""}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // inputError={icd1Val}
                                isItemSelected={!isNull(mainAuthorizationModal.DiagnosisCode2) ? true : false}
                                handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                showPatDx={false}
                                isReadOnly={isReadOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className='form-group input'>
                            <div className="d-flex justify-content-between">
                                {!isNull(mainAuthorizationModal.DiagnosisCode3) ?
                                    <>
                                        {icd3}
                                    </> :
                                    <label>ICD3</label>
                                }
                                {isReadOnly ? null : <i className='icon-Clip-path-group' onClick={() => handleOpenICD('DiagnosisCode3')}></i>}
                            </div>
                            <SuperICDandCPTSearch
                                type='server'
                                customData={RecentICDs}
                                PatDxData={[]}
                                id='Dx'
                                name='DiagnosisCode3'
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainAuthorizationModal.DiagnosisCode3}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display', },
                                    { columName: 'Description', bindingValue: 'Description', },
                                ]}
                                ApiLink={API_URL_Claim + "/ICDInstantSearch"}
                                method='post'
                                postBody={icdBody}
                                disabled={true}
                                // placeholder={""}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // inputError={icd1Val}
                                isItemSelected={!isNull(mainAuthorizationModal.DiagnosisCode3) ? true : false}
                                handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                showPatDx={false}
                                isReadOnly={isReadOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className='form-group input'>
                            <div className="d-flex justify-content-between">
                                {!isNull(mainAuthorizationModal.DiagnosisCode4) ?
                                    <>
                                        {icd4}
                                    </> :
                                    <label>ICD 4</label>
                                }
                                {isReadOnly ? null : <i className='icon-Clip-path-group' onClick={() => handleOpenICD('DiagnosisCode4')}></i>}
                            </div>
                            <SuperICDandCPTSearch
                                type='server'
                                customData={RecentICDs}
                                PatDxData={[]}
                                id='Dx'
                                name='DiagnosisCode4'
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainAuthorizationModal.DiagnosisCode4}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display', },
                                    { columName: 'Description', bindingValue: 'Description', },
                                ]}
                                ApiLink={API_URL_Claim + "/ICDInstantSearch"}
                                method='post'
                                postBody={icdBody}
                                disabled={true}
                                // placeholder={""}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // inputError={icd1Val}
                                isItemSelected={!isNull(mainAuthorizationModal.DiagnosisCode4) ? true : false}
                                handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                showPatDx={false}
                                isReadOnly={isReadOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        {/* <div className={AuthorizationValidationModal.ProcedureCodeVal ? 'form-group input error' : 'form-group input'}> */}
                        <div className='form-group input mb-0'>
                            <div className="d-flex justify-content-between">
                                <label>CPT <span className='req'>*</span></label>
                                <div className="label-head" onClick={() => handleAddNewCPT('', 'ProcedureCode')}>
                                    <button class="btn-icon-circle btn-xs">
                                        <i className='icon-plus-icon'></i>
                                    </button>
                                </div>
                                {<i className='icon-Clip-path-group' onClick={() => handleOpenCPTCode('ProcedureCode')}></i>}
                            </div>
                            <SuperICDandCPTSearch
                                type='server'
                                customData={RecentCPTs}
                                PatDxData={[]}
                                id='CPT'
                                name='ProcedureCode'
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainAuthorizationModal.ProcedureCode}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display', },
                                    { columName: 'Description', bindingValue: 'Description', },
                                ]}
                                ApiLink={API_URL_Claim + "/CPTInstantSearch"}
                                method='post'
                                postBody={cptBody}
                                disabled={true}
                                // placeholder={""}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                inputError={AuthorizationValidationModal.ProcedureCodeVal}
                                isItemSelected={!isNull(mainAuthorizationModal.ProcedureCode) ? true : false}
                                handleAddNewCode={(searchValue, name) => handleAddNewCPT(searchValue, name)}
                                showPatDx={false}
                                isReadOnly={isReadOnly}
                            />
                        </div>
                        {AuthorizationValidationModal.ProcedureCodeVal}
                        {/* </div> */}
                    </div>
                    {/* {isHomeCareCheck == 'true' ? */}
                    {/* <> */}
                    <div className="col-md-3 ">
                        <div className='input form-group'>
                            <div className='input form-group'>
                                <label htmlFor="Frequency">Program Type</label>
                                {/* <select type="text"
                                className='form-control'
                                name="InsuranceType"
                                id="InsuranceType"
                                value={mainAuthorizationModal.InsuranceType}
                                onChange={handleAuthorizationChange_}
                                disabled={OverallDD.length > 0 ? false : true}
                            >
                                {ProgramTypeDD.map((e, index) => (
                                    <option value={e.value} key={index}>
                                        {e.display}
                                    </option>
                                ))}
                            </select> */}
                                <SuperSearchList
                                    type="client"
                                    id='InsuranceType'
                                    name='InsuranceType'
                                    searchValue={mainAuthorizationModal.InsuranceType}
                                    data={ProgramTypeDD}
                                    onChange={handleAuthorizationChange_}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    isReadOnly={OverallDD.length > 0 ? false : true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className='input form-group'>
                            <div className="d-flex align-items-center justify-content-between">
                                <label htmlFor="Frequency">County</label>
                                {/* <p className="text">Amt : <span className="heading"><AmountFormatter amount={mainAuthorizationModal.CountyAmount} /></span></p> */}
                            </div>
                            <SuperSearch
                                // ApiLink={API_URL + "/ICDInstantSearch"}
                                // method="post"
                                // postBody={icdBody}
                                type='client'
                                customData={CountyDD}
                                // tableHeight={400}
                                // tableWidth="400px"
                                id='ProviderFeeScheduleID'
                                name='ProviderFeeScheduleID'
                                getSelectedData={handleSelectedData}
                                onChange={handleDiagnosisChange}
                                searchValue={mainAuthorizationModal?.ProviderFeeScheduleID}
                                tableData={[
                                    // { columName: 'ID', bindingValue: 'TaxonomyID', }ProviderFeeScheduleID,
                                    { columName: 'Code', bindingValue: 'display' },
                                    // { columName: 'StartDate', bindingValue: 'StartDate' },
                                    // { columName: 'EndDate', bindingValue: 'EndDate' },

                                ]}
                                disabled={true}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            />
                            {/* <select type="text"
                                className='form-control'
                                name="ProviderFeeScheduleID"
                                id="ProviderFeeScheduleID"
                                value={mainAuthorizationModal.ProviderFeeScheduleID}
                                onChange={handleAuthorizationChange_}
                                disabled={OverallDD.length > 0 ? false : true}
                            >
                                {CountyDD.map((e, index) => (
                                    <option value={e.value} data-amount={e.Amount} data-BillingEntity={e.BillingEntityID} key={index}>
                                        {e.display}
                                    </option>
                                ))}
                            </select> */}
                        </div>
                    </div>
                    {/* </> */}
                    {/* : null} */}

                    <div className="col-md-3 ">
                        <div className='form-group input mb-0'>
                            <div className="d-flex justify-content-between">
                                <label>Additional CPT Code</label>
                                {<i className='icon-Clip-path-group' onClick={() => handleOpenCPTCode('AdditionalCPTCode')}></i>}
                            </div>
                            <SuperICDandCPTSearch
                                type='server'
                                customData={RecentCPTs}
                                PatDxData={[]}
                                id='CPT'
                                name='AdditionalCPTCode'
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                searchValue={mainAuthorizationModal.AdditionalCPTCode}
                                searchBy={['display', 'Description']}
                                tableData={[
                                    { columName: 'Code', bindingValue: 'display', },
                                    { columName: 'Description', bindingValue: 'Description', },
                                ]}
                                ApiLink={API_URL_Claim + "/CPTInstantSearch"}
                                method='post'
                                postBody={cptBody}
                                disabled={true}
                                // placeholder={""}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // inputError={AuthorizationValidationModal.ProcedureCodeVal}
                                isItemSelected={!isNull(mainAuthorizationModal.AdditionalCPTCode) ? true : false}
                                handleAddNewCode={(searchValue, name) => handleAddNewCPT(searchValue, name)}
                                showPatDx={false}
                                isReadOnly={isReadOnly}
                            />
                        </div>
                    </div>
                    {/* <div className="col-md-3 ">
                        <div className='form-group input'>
                            <div className="d-flex justify-content-between">
                                {!isNull(mainAuthorizationModal.DiagnosisCode1) ?
                                    <>
                                        {icd1}
                                    </> :
                                    <label>ICD1</label>
                                }
                                {isReadOnly ? null : <i className='icon-Clip-path-group' onClick={() => handleOpenICD('DiagnosisCode1')}></i>}
                            </div>
                            <SuperSearchList
                                type='server'
                                id='DiagnosisCode1'
                                name='DiagnosisCode1'
                                searchValue={mainAuthorizationModal.DiagnosisCode1}
                                ApiLink={API_URL_Claim + "/ICDInstantSearch"}
                                method='post'
                                postBody={icdBody}
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // icon={true}
                                disabled={true}
                                isReadOnly={isReadOnly}
                                placeholder={"Search..."}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className='form-group input'>
                            <div className="d-flex justify-content-between">
                                {!isNull(mainAuthorizationModal.DiagnosisCode2) ?
                                    <>
                                        {icd2}
                                    </> :
                                    <label>ICD 2</label>
                                }
                                {isReadOnly ? null : <i className='icon-Clip-path-group' onClick={() => handleOpenICD('DiagnosisCode2')}></i>}
                            </div>
                            <SuperSearchList
                                type='server'
                                id='DiagnosisCode2'
                                name='DiagnosisCode2'
                                searchValue={mainAuthorizationModal.DiagnosisCode2}
                                ApiLink={API_URL_Claim + "/ICDInstantSearch"}
                                method='post'
                                postBody={icdBody}
                                onChange={handleDiagnosisChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                // icon={true}
                                disabled={true}
                                isReadOnly={isReadOnly}
                                placeholder={"Search..."}
                            />
                        </div>
                    </div> */}
                    {/* <div className="col-md-6">
                            <div className='input form-group'>
                                <label htmlFor="AuthorizationType">Bill Type</label>
                                <select type="text"
                                    className='form-control'
                                    name="AuthorizationType"
                                    id="AuthorizationType"
                                    value={mainAuthorizationModal.AuthorizationType}
                                    onChange={handleAuthorizationChange}
                                >
                                    {AuthorizationType.map((type) => {
                                        return (
                                            <option value={type.value} key={type.value}>{type.display}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div> */}

                    <div className="col-md-3 mb-1">
                        <div className='form-group input'>
                            <label htmlFor="AuthorizeUnits">Total Authorized Units</label>
                            <div className={AuthorizationValidationModal.AuthorizedUnitsVal ? 'form-group input error' : 'input form-group'}>
                                <input type="text"
                                    className='form-control'
                                    name="AuthorizeUnits"
                                    id="AuthorizeUnits"
                                    maxLength={50}
                                    autoComplete="off"
                                    onKeyPress={handleNumericCheck}
                                    value={mainAuthorizationModal.AuthorizeUnits}
                                    onChange={handleAuthorizationChange}
                                />
                                {AuthorizationValidationModal.AuthorizedUnitsVal}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 d-flex flex-column justify-content-end gap-1">
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="text">Schedule Units :</p>
                            <p className="heading Partialdenied-clr">{mainAuthorizationModal.ScheduleUnits}</p>
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                            <p className="text">Remaining Units :</p>
                            <p className="heading Partialdenied-clr">{mainAuthorizationModal.RemainingUnits}</p>
                        </div>
                    </div>
                    {/* {isHomeCareCheck == 'true' ? */}
                    <div className="col-md-3  d-flex flex-column justify-content-end gap-1">
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="text">Utitlized Units :</p>
                            <p className="heading Paid-clr">{mainAuthorizationModal.UtilizedUnits}</p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="text">Billing Entity</p>
                            <p className="heading">{handleBillingEntityValue(BillingEntityID)}</p>
                        </div>
                    </div>
                    {/* : null} */}
                    <div className="col-md-3">
                        <div className='input form-group'>
                            <label htmlFor="AuthorizationStatus">Status</label>
                            <SuperSearchList
                                type="client"
                                id='AuthorizationStatus'
                                name='AuthorizationStatus'
                                searchValue={mainAuthorizationModal.AuthorizationStatus}
                                data={AuthorizationStatus}
                                onChange={handleDropdwonChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                isReadOnly={AuthorizationID === 0 ? true : false}
                            />
                            {/* <select type="text"
                                className='form-control'
                                name="AuthorizationStatus"
                                id="AuthorizationStatus"
                                value={mainAuthorizationModal.AuthorizationStatus}
                                onChange={handleDropdwonChange}
                                disabled={AuthorizationID === 0 ? true : false}
                            >
                                {AuthorizationStatus.map((e, index) => (
                                    <option value={e.value} key={index}>
                                        {e.display}
                                    </option>
                                ))}
                            </select> */}
                        </div>
                    </div>

                    <div className="col-md-3 mb-1">
                        {/* <div className='input form-group'>
                                <label htmlFor="UtilizedUnits">Utilized Units</label>
                                <input type="text"
                                    className='form-control'
                                    name="UtilizedUnits"
                                    id="UtilizedUnits"
                                    readOnly
                                    value={mainAuthorizationModal.UtilizedUnits}
                                    onChange={handleAuthorizationChange}
                                />
                            </div> */}
                        <div className='input form-group'>
                            <label htmlFor="Frequency">Frequency</label>
                            <SuperSearchList
                                type="client"
                                id='Frequency'
                                name='Frequency'
                                searchValue={mainAuthorizationModal.Frequency}
                                data={AuthorizationFrequencyHomeCare}
                                onChange={handleDropdwonChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                isReadOnly={AuthorizationID === 0 ? true : false}
                            />
                            {/* <select type="text"
                                className='form-control'
                                name="Frequency"
                                id="Frequency"
                                value={mainAuthorizationModal.Frequency}
                                onChange={handleDropdwonChange}
                            >
                                {AuthorizationFrequencyHomeCare.map((type) => {
                                    return (
                                        <option value={type.value} key={type.value}>{type.display}</option>
                                    )
                                })}
                            </select> */}
                        </div>
                    </div>
                    <div className={BillingEntityID === '2' ? "col-md-2 mb-1" : "col-md-3 mb-1"}>
                        <div className={AuthorizationValidationModal.UnitsFrequencyVal ? 'form-group input error' : 'input form-group'}>
                            <label htmlFor="RemainingUnits">Units Per Freq <span className='req'>*</span> </label>
                            <input type="text"
                                className='form-control'
                                name="UnitsFrequency"
                                id="UnitsFrequency"
                                autoComplete="off"
                                onKeyPress={(event) => handleNumericCheck(event)}
                                value={mainAuthorizationModal.UnitsFrequency}
                                onChange={handleAuthorizationChange}
                            />

                            {AuthorizationValidationModal.UnitsFrequencyVal}
                        </div>

                    </div>
                    {BillingEntityID === '2' ?
                        <div className="col-md-1 d-flex align-items-center mt-3 ps-0">
                            <p className="heading">{CalculatePerunitHours(mainAuthorizationModal.UnitsFrequency)}</p>
                        </div>
                        : null}
                    <div className="col-md-6 mb-1">
                        <div className="input">
                            <label>Authorization Document</label>
                            {mainAuthorizationModal.FileName ? (
                                <div className='d-flex gap-3 align-items-center mt-1'>
                                    <p className='heading fst-italic validation_message'>{mainAuthorizationModal.FileName} {/*<span className='ms-1'> 30 KB</span>*/}</p>
                                    <div className='d-flex align-items-center gap-2'>
                                        {isFileChanged ? null :
                                            <div className="hk-uploadFile__btns m-0">
                                                <button className="btn-icon-transparent icon-box" onClick={() => DownloadFile('AuthorizationDocument')}>
                                                    <i className="icon-upload-converted"></i>
                                                </button>
                                            </div>
                                        }

                                        <div className='ar-upload-btn' onClick={() => handleRemoveImage('AuthorizationDocument')}>
                                            <i className='icon-delete'></i>
                                        </div>
                                        {isFileChanged ? null :
                                            <button className='border-0 no-width bg-transparent' onClick={ViewPdf}>
                                                <span class="icon-pdf-followup fs-19"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span></span>
                                            </button>
                                        }
                                    </div>
                                </div>
                            ) : (
                                <div className='upload-file form-control'>
                                    <input
                                        type="file"
                                        accept=".pdf"
                                        id='AuthorizationDocument'
                                        name="AuthorizationDocument"
                                        onChange={handleImageChange}
                                    />
                                    <label htmlFor="AuthorizationDocument">
                                        <i className='bi bi-paperclip'></i>
                                        {mainAuthorizationModal.FileName ? mainAuthorizationModal.FileName : "Upload a File"}
                                    </label>
                                </div>
                            )}
                        </div>

                    </div>
                    {isADC && !isNull(mainAuthorizationModal.AdditionalCPTCode) ?
                        <div className="col-md-6 mt-4">
                            <div className='d-flex align-items-center gap-6'>
                                <div className="custom_check_box d-flex">
                                    <input type="checkbox"
                                        className="form-check-input m-0 p-0"
                                        name="IsTranspotation"
                                        id="IsTranspotation"
                                        autoComplete="off"
                                        checked={mainAuthorizationModal.IsTranspotation}
                                        onChange={handleAuthorizationChange}
                                    />
                                </div>
                                <p className="text font-m" for="inlineCheckbox1">Transportation  </p>
                            </div>
                        </div> : null
                    }

                    <div className="form-group input col-md-12">
                        <label htmlFor="Description">Authorization Notes</label>
                        <textarea
                            className="form-control doc-textarea"
                            id="Notes"
                            name="Notes"
                            value={mainAuthorizationModal.Notes}
                            onChange={handleDropdwonChange}
                            rows={2}
                        ></textarea>
                    </div>
                </div >
                {/* {   {isADC ? null : == 'true' && ( */}
                <div className="ar_authorization-popup">
                    {isADC ? null :
                        <div className="d-flex justify-content-between align-items-center pb-2">
                            <div>
                                <p className="text ar-light-color pb-1">Schedule Type</p>
                                <div className='d-flex align-items-center gap-15'>
                                    <div className="ar_radio-btn d-flex align-items-center gap-2">
                                        <input
                                            type="radio"
                                            // type="checkbox"
                                            id="isScheduleDaily"
                                            name="isScheduleDaily"
                                            checked={mainAuthorizationModal.isScheduleDaily}
                                            onChange={handleAuthorizationChange}
                                        />
                                        <p className="text ar-orange-text">Daily</p>
                                    </div>
                                    <div className="ar_radio-btn d-flex align-items-center gap-2">
                                        <input
                                            type="radio"
                                            // type="checkbox"
                                            id="isScheduleFloating"
                                            name="isScheduleFloating"
                                            checked={mainAuthorizationModal.isScheduleFloating}
                                            onChange={handleAuthorizationChange}
                                        />
                                        <p className="text ar-orange-text">Floating</p>
                                    </div>
                                </div>
                            </div>
                            {/* For Daily */}
                            {mainAuthorizationModal.isScheduleDaily === true ?
                                <div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="fs-11 text ar-light-color">Live In</p>
                                        <div className="m-0 mb-1 pe-0">
                                            <div className="form-check form-switch mh-unset radio_button ms-0">
                                                <input className="form-check-input position-static ps-0 ms-0"
                                                    type="checkbox"
                                                    id="isLiveIn"
                                                    name="isLiveIn"
                                                    checked={mainAuthorizationModal.isLiveIn}
                                                    onChange={handleAuthorizationChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center gap-15">
                                        <p className="fs-11 text ar-light-color">Split Shift</p>
                                        <div className="m-0 mb-1 pe-0">
                                            <div className="form-check form-switch mh-unset radio_button ms-0">
                                                <input className="form-check-input position-static ps-0 ms-0"
                                                    type="checkbox"
                                                    id="isSplitShift"
                                                    name="isSplitShift"
                                                    checked={mainAuthorizationModal.isSplitShift}
                                                    onChange={handleAuthorizationChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                :
                                <div className="d-flex align-items-center gap-12 daily-input">
                                    <div className="">
                                        <div className='input form-group'>
                                            <label htmlFor="MinDailyLimit">Daily Limit Min</label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="DailyLimitMin"
                                                id="DailyLimitMin"
                                                value={mainAuthorizationModal.DailyLimitMin}
                                                onChange={handleAuthorizationChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="">
                                        <div className='input form-group'>
                                            <label htmlFor="MaxDailyLimit">Daily Limit Max</label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="DailyLimitMax"
                                                id="DailyLimitMax"
                                                value={mainAuthorizationModal.DailyLimitMax}
                                                onChange={handleAuthorizationChange}
                                            />
                                        </div>
                                    </div>

                                </div>
                            }

                        </div>
                    }


                    <div className="app-accordian ">
                        {mainAuthorizationModal.isScheduleDaily === true ?
                            <>
                                <Accordion defaultExpanded>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <p className="heading ">Main Shift</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className="authorization-table bg-white">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th className="text font-m fs-11">Mon</th>
                                                        <th className="text font-m fs-11">Tue</th>
                                                        <th className="text font-m fs-11">Wed</th>
                                                        <th className="text font-m fs-11">Thur</th>
                                                        <th className="text font-m fs-11">Fri</th>
                                                        <th className="text font-m fs-11">Sat</th>
                                                        <th className="text font-m fs-11">Sun</th>
                                                        <th className="text font-m fs-11">Total</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <div className="d-flex flex-column align-items-center">
                                                                {BillingEntityID === '2' ?
                                                                    <>
                                                                        <p className="fs-10 ar-dark-color text font-m">Hours</p>
                                                                        <p className="line"></p>
                                                                        <p className="fs-10 ar-dark-color text font-m">Units</p>
                                                                    </>
                                                                    :
                                                                    <p className="fs-10 ar-dark-color text font-m">Units</p>
                                                                }
                                                                {/* <p className="fs-10 ar-dark-color text font-m">Hours</p>
                                                                    <p className="line"></p>
                                                                    <p className="fs-10 ar-dark-color text font-m">Units</p> */}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex flex-column align-items-center gap-15">
                                                                <div className='input form-group'>
                                                                    <input
                                                                        type="text"
                                                                        className='form-control'
                                                                        id="Mon"
                                                                        name="Mon"
                                                                        value={mainAuthorizationModal.Mon}
                                                                        onChange={handleAuthorizationChange}
                                                                        onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                    />
                                                                </div>
                                                                {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(mainAuthorizationModal.Mon)}</p> : null}
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className="d-flex flex-column align-items-center gap-15">
                                                                <div className='input form-group'>
                                                                    <input
                                                                        type="text"
                                                                        className='form-control'
                                                                        id="Tue"
                                                                        name="Tue"
                                                                        value={mainAuthorizationModal.Tue}
                                                                        onChange={handleAuthorizationChange}
                                                                        onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                    />
                                                                </div>
                                                                {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(mainAuthorizationModal.Tue)}</p> : null}
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className="d-flex flex-column align-items-center gap-15">
                                                                <div className='input form-group'>
                                                                    <input
                                                                        type="text"
                                                                        className='form-control'
                                                                        id="Wed"
                                                                        name="Wed"
                                                                        value={mainAuthorizationModal.Wed}
                                                                        onChange={handleAuthorizationChange}
                                                                        onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                    />
                                                                </div>
                                                                {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(mainAuthorizationModal.Wed)}</p> : null}
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className="d-flex flex-column align-items-center gap-15">
                                                                <div className='input form-group'>
                                                                    <input
                                                                        type="text"
                                                                        className='form-control'
                                                                        id="Thu"
                                                                        name="Thu"
                                                                        value={mainAuthorizationModal.Thu}
                                                                        onChange={handleAuthorizationChange}
                                                                        onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                    />
                                                                </div>
                                                                {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(mainAuthorizationModal.Thu)}</p> : null}
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className="d-flex flex-column align-items-center gap-15">
                                                                <div className='input form-group'>
                                                                    <input
                                                                        type="text"
                                                                        className='form-control'
                                                                        id="Fri"
                                                                        name="Fri"
                                                                        value={mainAuthorizationModal.Fri}
                                                                        onChange={handleAuthorizationChange}
                                                                        onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                    />
                                                                </div>
                                                                {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(mainAuthorizationModal.Fri)}</p> : null}
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className="d-flex flex-column align-items-center gap-15">
                                                                <div className='input form-group'>
                                                                    <input
                                                                        type="text"
                                                                        className='form-control'
                                                                        id="Sat"
                                                                        name="Sat"
                                                                        value={mainAuthorizationModal.Sat}
                                                                        onChange={handleAuthorizationChange}
                                                                        onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                    />
                                                                </div>
                                                                {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(mainAuthorizationModal.Sat)}</p> : null}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex flex-column align-items-center gap-15">
                                                                <div className='input form-group'>
                                                                    <input
                                                                        type="text"
                                                                        className='form-control'
                                                                        id="Sun"
                                                                        name="Sun"
                                                                        value={mainAuthorizationModal.Sun}
                                                                        onChange={handleAuthorizationChange}
                                                                        onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                    />
                                                                </div>
                                                                {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(mainAuthorizationModal.Sun)}</p> : null}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex flex-column gap-25">
                                                                {BillingEntityID === '2' ? <p className="text font-m fs-11 clr-orange">{calculatetotalHour()}</p> : null}
                                                                {BillingEntityID === '1' || BillingEntityID === '3' ? <p className="text font-m fs-11 clr-orange">{calculatetotalHour()}</p> : BillingEntityID === '2' ? <p className="text font-m fs-11 clr-orange">{calculatetotalUnit()}</p> : null}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                {mainAuthorizationModal.isSplitShift === true ?
                                    <Accordion defaultExpanded>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <div className="d-flex justify-content-between w-100 align-items-center">
                                                <p className="heading">Split Shift  </p>
                                                <div className='d-flex plus-shift-icon' onClick={(e) => { handleAddNewShift(); e.stopPropagation() }}>
                                                    <i className='icon-dash-plus fs-22'></i>
                                                </div>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            {/* <p className="heading" onClick={() => handleAddNewShift()}>Add</p> */}
                                            <div className="authorization-table bg-white split-table">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th className="text font-m fs-11">Mon</th>
                                                            <th className="text font-m fs-11">Tue</th>
                                                            <th className="text font-m fs-11">Wed</th>
                                                            <th className="text font-m fs-11">Thur</th>
                                                            <th className="text font-m fs-11">Fri</th>
                                                            <th className="text font-m fs-11">Sat</th>
                                                            <th className="text font-m fs-11">Sun</th>
                                                            <th className="text font-m fs-11">Total</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {splitShiftData && splitShiftData.map((item, index) => {
                                                            return (
                                                                <tr>
                                                                    <td>
                                                                        {BillingEntityID === '2' ?
                                                                            <>
                                                                                <p className="fs-10 ar-dark-color text font-m">Hours</p>
                                                                                <p className="line"></p>
                                                                                <p className="fs-10 ar-dark-color text font-m">Units</p>
                                                                            </>
                                                                            :
                                                                            <p className="fs-10 ar-dark-color text font-m">Units</p>
                                                                        }
                                                                        {/* <div className="d-flex flex-column align-items-center">
                                                                                <p className="fs-10 ar-dark-color text font-m">Hours</p>
                                                                                <p className="line"></p>
                                                                                <p className="fs-10 ar-dark-color text font-m">Units</p>
                                                                            </div> */}
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex flex-column align-items-center gap-15">
                                                                            <div className='input form-group'>
                                                                                <input
                                                                                    type="text"
                                                                                    className='form-control'
                                                                                    id="Mon"
                                                                                    name="Mon"
                                                                                    value={item.Mon}
                                                                                    onChange={(e) => handleChangeSplitData(e, index)}
                                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                />
                                                                            </div>
                                                                            {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(item.Mon)}</p> : null}
                                                                        </div>
                                                                    </td>

                                                                    <td>
                                                                        <div className="d-flex flex-column align-items-center gap-15">
                                                                            <div className='input form-group'>
                                                                                <input
                                                                                    type="text"
                                                                                    className='form-control'
                                                                                    id="Tue"
                                                                                    name="Tue"
                                                                                    value={item.Tue}
                                                                                    onChange={(e) => handleChangeSplitData(e, index)}
                                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                />
                                                                            </div>
                                                                            {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(item.Tue)}</p> : null}
                                                                        </div>
                                                                    </td>

                                                                    <td>
                                                                        <div className="d-flex flex-column align-items-center gap-15">
                                                                            <div className='input form-group'>
                                                                                <input
                                                                                    type="text"
                                                                                    className='form-control'
                                                                                    id="Wed"
                                                                                    name="Wed"
                                                                                    value={item.Wed}
                                                                                    onChange={(e) => handleChangeSplitData(e, index)}
                                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                />
                                                                            </div>
                                                                            {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(item.Wed)}</p> : null}
                                                                        </div>
                                                                    </td>

                                                                    <td>
                                                                        <div className="d-flex flex-column align-items-center gap-15">
                                                                            <div className='input form-group'>
                                                                                <input
                                                                                    type="text"
                                                                                    className='form-control'
                                                                                    id="Thu"
                                                                                    name="Thu"
                                                                                    value={item.Thu}
                                                                                    onChange={(e) => handleChangeSplitData(e, index)}
                                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                />
                                                                            </div>
                                                                            {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(item.Thu)}</p> : null}
                                                                        </div>
                                                                    </td>

                                                                    <td>
                                                                        <div className="d-flex flex-column align-items-center gap-15">
                                                                            <div className='input form-group'>
                                                                                <input
                                                                                    type="text"
                                                                                    className='form-control'
                                                                                    id="Fri"
                                                                                    name="Fri"
                                                                                    value={item.Fri}
                                                                                    onChange={(e) => handleChangeSplitData(e, index)}
                                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                />
                                                                            </div>
                                                                            {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(item.Fri)}</p> : null}
                                                                        </div>
                                                                    </td>

                                                                    <td>
                                                                        <div className="d-flex flex-column align-items-center gap-15">
                                                                            <div className='input form-group'>
                                                                                <input
                                                                                    type="text"
                                                                                    className='form-control'
                                                                                    id="Sat"
                                                                                    name="Sat"
                                                                                    value={item.Sat}
                                                                                    onChange={(e) => handleChangeSplitData(e, index)}
                                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                />
                                                                            </div>
                                                                            {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(item.Sat)}</p> : null}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex flex-column align-items-center gap-15">
                                                                            <div className='input form-group'>
                                                                                <input
                                                                                    type="text"
                                                                                    className='form-control'
                                                                                    id="Sun"
                                                                                    name="Sun"
                                                                                    value={item.Sun}
                                                                                    onChange={(e) => handleChangeSplitData(e, index)}
                                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                />
                                                                            </div>
                                                                            {BillingEntityID === '2' ? <p className="text font-m">{calculateUnitsSplit(item.Sun)}</p> : null}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex flex-column gap-25">
                                                                            {BillingEntityID === '2' ? <p className="text font-m fs-11 clr-orange">{calculateTotalHours(item)}</p> : null}
                                                                            {BillingEntityID === '1' || BillingEntityID === '3' ? <p className="text font-m fs-11 clr-orange">{calculateTotalHours(item)}</p> : <p className="text font-m fs-11 clr-orange">{calculateTotalSplitUnits(item)}</p>}



                                                                            {/* {BillingEntityID === '2' ? <p className="text font-m fs-11 clr-orange">{calculateTotalHours(item)}</p> : null}
                                                                            <p className="text font-m fs-11 clr-orange">{calculateTotalSplitUnits(item)}</p> */}

                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}

                                                    </tbody>
                                                </table>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                    : null}

                            </> :
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <p className="heading ">Main Shift</p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className="authorization-table bg-white">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th className="text font-m fs-11">Mon</th>
                                                    <th className="text font-m fs-11">Tue</th>
                                                    <th className="text font-m fs-11">Wed</th>
                                                    <th className="text font-m fs-11">Thur</th>
                                                    <th className="text font-m fs-11">Fri</th>
                                                    <th className="text font-m fs-11">Sat</th>
                                                    <th className="text font-m fs-11">Sun</th>
                                                    <th className="text font-m fs-11">Total</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <div className="d-flex flex-column align-items-center">
                                                            <p className="fs-10 ar-dark-color text font-m">Min Hours</p>
                                                            <p className="line"></p>
                                                            <p className="fs-10 ar-dark-color text font-m">Max Hours</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-10">
                                                            <div className='input form-group'>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    id="MonMin"
                                                                    name="MonMin"
                                                                    value={mainAuthorizationModal.MonMin}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                            <div className='input form-group'>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    id="MonMax"
                                                                    name="MonMax"
                                                                    value={mainAuthorizationModal.MonMax}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-10">
                                                            <div className='input form-group'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    id="TueMin"
                                                                    name="TueMin"
                                                                    value={mainAuthorizationModal.TueMin}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                            <div className='input form-group'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    id="TueMax"
                                                                    name="TueMax"
                                                                    value={mainAuthorizationModal.TueMax}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-10">
                                                            <div className='input form-group'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    id="WedMin"
                                                                    name="WedMin"
                                                                    value={mainAuthorizationModal.WedMin}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                            <div className='input form-group'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    id="WedMax"
                                                                    name="WedMax"
                                                                    value={mainAuthorizationModal.WedMax}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-10">
                                                            <div className='input form-group'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    id="ThuMin"
                                                                    name="ThuMin"
                                                                    value={mainAuthorizationModal.ThuMin}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                            <div className='input form-group'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    id="ThuMax"
                                                                    name="ThuMax"
                                                                    value={mainAuthorizationModal.ThuMax}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-10">
                                                            <div className='input form-group'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    id="FriMin"
                                                                    name="FriMin"
                                                                    value={mainAuthorizationModal.FriMin}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                            <div className='input form-group'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    id="FriMax"
                                                                    name="FriMax"
                                                                    value={mainAuthorizationModal.FriMax}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-10">
                                                            <div className='input form-group'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    id="SatMin"
                                                                    name="SatMin"
                                                                    value={mainAuthorizationModal.SatMin}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                            <div className='input form-group'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    id="SatMax"
                                                                    name="SatMax"
                                                                    value={mainAuthorizationModal.SatMax}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-10">
                                                            <div className='input form-group'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    id="SunMin"
                                                                    name="SunMin"
                                                                    value={mainAuthorizationModal.SunMin}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                            <div className='input form-group'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    id="SunMax"
                                                                    name="SunMax"
                                                                    value={mainAuthorizationModal.SunMax}
                                                                    onChange={handleAuthorizationChange}
                                                                    onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-25">
                                                            <p className="text font-m fs-11 clr-orange">{totalMinHrs}</p>
                                                            <p className="text font-m fs-11 clr-orange">{totalMaxHrs}</p>

                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        }
                    </div>
                </div>
                {/* )} */}
                <Modal show={modalActive} onHide={() => setModalActive(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-md hk-login-v1 hk-modal-v1">
                    <Modal.Body>
                        <div className="download-header">
                            <div className='hide-me'></div>
                            {/* <button className="btn download-btn">
                                 Download PDF
                                   </button> */}

                            <button className="btn-icon-transparent" onClick={() => setModalActive(false)}>
                                <i className="icon-Icon-metro-cross"></i>
                            </button>
                        </div>
                        <div className="pdfView-box">

                            {!isNull(txtFile) ? txtFile : ''}
                            {!isNull(imgFile) ? <img src={imgFile} alt='Image' /> : ''}

                        </div>
                        {isLoading ? <Loader /> : null}

                        {pdfFile &&
                            <>
                                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                                    <Viewer fileUrl={pdfFile}
                                        defaultScale={1}
                                        plugins={[defaultLayoutPluginInstance]} />
                                </Worker>
                            </>
                        }
                    </Modal.Body>
                    <div className='btns-group text-end px-3 py-3 br-top-1 br-clr'>
                        <button className='btn btn-gray' onClick={() => setModalActive(false)}>Cancel</button>
                    </div>
                </Modal>
            </>
        )
    }



    const [isOpenNewDiagnosis, setisOpenNewDiagnosis] = useState(false)
    const [icdCode, setIcdCode] = useState()
    const [ActiveICDName, setActiveICDName] = useState('')
    const handleAddNewICD = (searchValue, name) => {
        setActiveICDName(name)
        setIcdCode(searchValue)
        setisOpenNewDiagnosis(true)
    }
    const handleCloseICD = () => {
        setisOpenNewDiagnosis(false)
        setIcdCode()
        setActiveICDName('')
    }
    const handleOnSaveICD = (selectedData) => {
        if (!isNull(ActiveICDName)) {
            handleSelectedData(selectedData, ActiveICDName, 'server')
        }
        handleCloseICD()
    }
    let NewICDPopup = ''
    if (isOpenNewDiagnosis) {
        NewICDPopup = <AddNewDiagnosis isOpenDiagnosis={isOpenNewDiagnosis} onClose={handleCloseICD} Diagnosisvalue={icdCode} onDeleteProcedure={handleCloseICD} onDeleteDiagnosis={handleCloseICD} IsOpen={true} onICDSave={handleOnSaveICD} />
    }

    // open CPT
    const [isOpenProcedureCode, setisOpenProcedureCode] = useState(false)
    const handleAddNewCPT = (searchValue, name) => {
        setActiveICDName(name)
        setIcdCode(searchValue)
        setisOpenProcedureCode(true)
    }
    const handleCloseCPT = () => {
        setisOpenProcedureCode(false)
        setIcdCode()
        setActiveICDName('')
    }
    const handleOnSaveCPT = (selectedData) => {
        if (!isNull(ActiveICDName)) {
            handleSelectedData(selectedData, ActiveICDName, 'server')
        }
        handleCloseCPT()
    }
    let NewCPTPopup = ''
    if (isOpenProcedureCode) {
        NewCPTPopup = <AddNewProcedureCodes isOpenProcedure={isOpenProcedureCode} onClose={handleCloseCPT} ProcedureCode={icdCode} onDeleteProcedure={handleCloseCPT} handleOnSaveICD={handleOnSaveCPT} isOpenFromList={true} />
    }
    return (
        <React.Fragment>
            {DeleteConfirmation}
            {ICDpopup}
            {NewICDPopup}
            {ProcedureSerachPopup}
            {NewCPTPopup}
            {AuthrizedPopup}
            <Modal show={UpdateAuthorizationNumber} onHide={UpdateAuthorizationNumber} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 za-exit-group za-update-subscriber-id za-update-authoriaztion">
                <Modal.Body>
                    {isLoading ? <Loader /> : null}
                    <div className='paragraph d-flex gap-1'>
                        <i className='icon-Vector13 fs-16'></i>
                        <p className=' text fs-12 fst-italic'>You have {claimCounts} visits associated with the previous Authorization # [{previousAuthorizationNumber}]. Do you want to update the Authorization # [{NewAuthorizationNumber}] for these visits as well?</p>
                    </div>
                    <div className='za-button text-end'>
                        <button className='btn btn-cancel heading fs-12 px-10' onClick={handleAutorizedClose}> No</button>
                        <button className='btn btn-exit heading fs-12 px-10' onClick={handleAutorized}> Yes</button>
                    </div>
                </Modal.Body>
            </Modal>
            {type && type === "Wizard" ?
                <div>
                    {AuditPopup}
                    {PopupScreen}
                    {isLoading ? <Loader /> : null}
                    <div className="add_autherization mb-2">
                        {AddnewAuth()}
                    </div>
                    {/* <ModalFooter isSaved={onInsuranceSave ? onDeleteInsurance : onClose} handleSave={handleSaveAuthorization} IsEditAllowed={IsEditAllowed} /> */}
                    <div className={"btns-group text-end modal_footer br-top-1 br-clr d-flex justify-content-between flex-column flex-sm-row align-items-center gap-3"} >
                        <div>
                            {DataImportMenu[1].status === 'true' ? <button className="btn btn-view px-2" onClick={() => handleProcessPendingData()}>Proccesed</button> : null}
                        </div>
                        <div className="btns-group d-flex justify-content-center align-items-center">
                            <button className="btn btn-gray" onClick={onClose}>
                                Cancel
                            </button>

                            <button className={IsEditAllowed ? 'btn btn-orange ' : 'btn btn-orange disabled'} disabled={!IsEditAllowed} onClick={handleSaveAuthorization}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
                :
                <>
                    <Modal show={IsOpenAuthorization} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 add_autherization modal-c-lg">
                        {AuditPopup}
                        {PopupScreen}
                        <Modal.Body>
                            <ModalHeader HeaderName={SetAuthorizationName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onClose} key={2132} Name={'Authorization'} IsDeleteAllowed={IsDeleteAllowed} />
                            {isLoading ? <Loader /> : null}
                            {AddnewAuth()}
                        </Modal.Body>
                        <ModalFooter isSaved={onInsuranceSave ? onDeleteInsurance : onClose} handleSave={handleSaveAuthorization} IsEditAllowed={IsEditAllowed} />
                        {/* <ModalFooter isSaved={onInsuranceSave ? IsOpenAuthorization : onClose} handleSave={handleSaveAuthorization} /> */}
                    </Modal>
                </>
            }

            {AuthorizationID === 0 ? <Modal show={npiModal} onHide={onCloseProocedNpi} backdrop="static" keyboard={false} dialogClassName="app-modal modal-lg proceed_npi_modal auth-proceed_npi_modal w-100">
                <Modal.Body>
                    {/* <SearchHeader masterListButton={proceedNPI} /> */}
                    <ModalHeader HeaderName={proceedHeader} DeletePopup={""} isClosed={onCloseProocedNpi} key={631} Name={'SwitchPractice'} />
                    <div className='container-fluid  br-clr'>
                        <div className="row">
                            <div className={`input px-2 mb-2 ${AuthFileValidation?.UploadedFile ? 'error' : ''}`}>
                                {mainAuthorizationModal.FileName ? (
                                    <div className='d-flex gap-3 align-items-center'>
                                        <div className="d-flex align-items-center gap-1">
                                            <div className="ar-pdf-icon d-flex justify-content-center align-items-center">
                                                <PdfIcon classes={'fs-11'} />
                                            </div>
                                            <div className="d-flex flex-column">
                                                <p className='heading font-m fs-11 validation_message npi-vald text-nowrap'>{mainAuthorizationModal.FileName}</p>
                                                {/* <span className='heading font-m fs-11 '> 30 KB</span> */}
                                            </div>
                                        </div>
                                        <div className='d-flex align-items-center gap-2'>
                                            <div className='ar-upload-btn' onClick={() => handleRemoveImage('AuthorizationDocument')}>
                                                <i className='icon-delete fs-13'></i>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='upload-file form-control'>
                                        <input
                                            type="file"
                                            id='AuthorizationDocument'
                                            name="AuthorizationDocument"
                                            onChange={handleImageChange}
                                        />
                                        <label htmlFor="AuthorizationDocument">
                                            <i className='bi bi-paperclip'></i>
                                            {mainAuthorizationModal.FileName ? mainAuthorizationModal.FileName : "Upload a File"}
                                        </label>
                                    </div>
                                )}
                            </div>
                            <div className='input form-group px-2'>

                                <SuperSearchList
                                    type="client"
                                    id='PatientInsuranceID'
                                    name='PatientInsuranceID'
                                    searchValue={mainAuthorizationModal.PatientInsuranceID}
                                    data={InsuranceListModal}
                                    onChange={handleDropdwonChange}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                    inputError={AuthorizationValidationModal.InusranceIDVal}
                                />
                                {/* </div> */}
                                {AuthorizationValidationModal.InusranceIDVal}
                            </div>
                            <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                <button className="btn btn-orange btn-xs no-width rounded mb-0 proceed_btn" onClick={handleNpiRegistry} >Proceed <i className="icon-arrow-right"></i></button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> : null}
        </React.Fragment>

    )
}

export default AddNewAuthorization